// This file is auto-generated by @hey-api/openapi-ts

import { type Options, apiAddressesFormatPost, apiAddressesIdFormatGet, apiAddressesIdFormatPatch, apiBinlookupsFormatGetCollection, apiBinlookupsBinFormatDelete, apiBinlookupsBinFormatGet, apiTransactionSignatureFormatPost, apiTransactionsauthorizedFormatGetCollection, apiTransactionsauthorizedTransactionIdFormatGet, faCheck, userLogin, logout, apiBatchesFormatGetCollection, apiBatchesBatchIdFormatGet, apiBinlookupsuploadFormatPost, apiCardTokensTokenFormatGet, apiCheckTokensTokenFormatGet, apiCustomerAddressAuditsFormatGetCollection, apiCustomersFormatGetCollection, apiCustomersFormatPost, apiCustomersIdFormatGet, apiCustomersIdFormatPatch, apiUsersmemfaProvidersProviderFormatGet, apiCustomersinvoicesIdpayFormatPost, apiInvoicesFormatGetCollection, apiInvoicesFormatPost, apiInvoicesclosedIdFormatPatch, apiInvoicesdownloadIdGet, apiInvoicesexportGetCollection, apiInvoicespayIdFormatPost, apiInvoicespreviewFormatPost, apiInvoicespublicIdFormatGet, apiInvoicesresendIdFormatPost, apiInvoicesIdFormatGet, apiInvoicesIdFormatPatch, apiMerchantDefinedFieldsFormatGetCollection, apiMerchantDefinedFieldsFormatPost, apiMerchantDefinedFieldsIdFormatDelete, apiMerchantDefinedFieldsIdFormatGet, apiMerchantDefinedFieldsIdFormatPatch, apiMerchantsFormatGetCollection, apiMerchantsFormatPost, apiMerchantsMerchAccountIdFormatDelete, apiMerchantsMerchAccountIdFormatGet, apiMerchantsMerchAccountIdFormatPatch, apiObjectFilesFormatGetCollection, apiObjectFilesFormatPost, apiPaymentsIdFormatGet, apiProductCategoriesFormatGetCollection, apiProductCategoriesFormatPost, apiProductCategoriesIdFormatDelete, apiProductCategoriesIdFormatGet, apiProductCategoriesIdFormatPatch, apiProductDetailByLocationFormatGetCollection, apiProductDetailByLocationFormatPost, apiProductDetailByLocationIdFormatDelete, apiProductDetailByLocationIdFormatGet, apiProductDetailByLocationIdFormatPatch, apiProductLocationsFormatGetCollection, apiProductLocationsFormatPost, apiProductLocationsIdFormatDelete, apiProductLocationsIdFormatGet, apiProductLocationsIdFormatPatch, apiProductPackageProductDetailByLocationPackageIdFormatGetCollection, apiProductPackagesFormatGetCollection, apiProductPackagesFormatPost, apiProductPackagesIdFormatDelete, apiProductPackagesIdFormatGet, apiProductPackagesIdFormatPatch, apiProductStockOrderItemsStockOrderIdFormatGetCollection, apiProductStockOrderStatusIdFormatPatch, apiProductStockOrdersFormatGetCollection, apiProductStockOrdersFormatPost, apiProductStockOrdersIdFormatDelete, apiProductStockOrdersIdFormatGet, apiProductStockOrdersIdFormatPatch, apiProductsFormatGetCollection, apiProductsFormatPost, apiProductsIdFormatDelete, apiProductsIdFormatGet, apiProductsIdFormatPatch, apiPlansFormatGetCollection, apiPlansFormatPost, apiPlansIdFormatDelete, apiPlansIdFormatGet, apiPlansIdFormatPatch, apiRecurStatusRecurIdFormatPatch, apiRecursFormatGetCollection, apiRecursFormatPost, apiRecursIdFormatDelete, apiRecursIdFormatGet, apiRecursIdFormatPatch, apiTransactionSignatureIdFormatGet, apiBatchesreopenBatchIdFormatPost, apiManagebdkFormatGetCollection, apiManagebdkFormatPost, apiManagebdkIdFormatDelete, apiManagebdkIdFormatGet, apiManagebdkIdFormatPatch, apiTransactionsallFormatGetCollection, apiTransactionsauthToSaleFormatPost, apiTransactionsbatchCloseFormatPost, apiTransactionsbatchedFormatGetCollection, apiTransactionsbatchedTransactionIdFormatGet, apiTransactionsblindReturnFormatPost, apiTransactionscheckStoreFormatPost, apiTransactionsdeclinedFormatGetCollection, apiTransactionsdeclinedTransactionIdFormatGet, apiTransactionserrorFormatGetCollection, apiTransactionserrorTransactionIdFormatGet, apiTransactionsincrementalFormatPost, apiTransactionsreEnterFormatPost, apiTransactionsreturnFormatPost, apiTransactionsreversalFormatPost, apiTransactionssaleFormatPost, apiTransactionssettledFormatGetCollection, apiTransactionssettledTransactionIdFormatGet, apiTransactionsstoreFormatPost, apiTransactionsvoidFormatPost, apiTransactionsTransactionIdreceiptFormatGet, apiUsersFormatGetCollection, apiUsersPost, apiUsersmeFormatGet, apiUsersmechangePasswordFormatPatch, apiUsersmedisableMfaFormatPatch, apiUsersmegenerateMfaBackupCodesFormatPost, apiUsersmegenerateMfaEmailAuthCodeFormatPost, apiUsersmegenerateMfaGoogleTotpFormatPost, apiUsersmemfaProvidersFormatGetCollection, apiUsersmemfaProvidersFormatPost, apiUsersmepreferMfaFormatPatch, apiUsersmesetupMfaEmailAuthCodeFormatPost, apiUsersmesetupMfaGoogleTotpFormatPost, apiUsersrequestResetPasswordFormatPost, apiUsersresetMfaAccountIdFormatPatch, apiUsersresetPasswordFormatPost, apiUsersresetPasswordIdFormatGet, apiUsersIdDelete, apiUsersIdFormatGet, apiUsersIdFormatPatch } from '../sdk.gen';
import { queryOptions, type UseMutationOptions, infiniteQueryOptions, type InfiniteData, type DefaultError } from '@tanstack/react-query';
import type { ApiAddressesFormatPostData, ApiAddressesFormatPostError, ApiAddressesFormatPostResponse, ApiAddressesIdFormatGetData, ApiAddressesIdFormatPatchData, ApiAddressesIdFormatPatchError, ApiAddressesIdFormatPatchResponse, ApiBinlookupsFormatGetCollectionData, ApiBinlookupsFormatGetCollectionResponse, ApiBinlookupsBinFormatDeleteData, ApiBinlookupsBinFormatDeleteError, ApiBinlookupsBinFormatDeleteResponse, ApiBinlookupsBinFormatGetData, ApiTransactionSignatureFormatPostData, ApiTransactionSignatureFormatPostError, ApiTransactionSignatureFormatPostResponse, ApiTransactionsauthorizedFormatGetCollectionData, ApiTransactionsauthorizedFormatGetCollectionResponse, ApiTransactionsauthorizedTransactionIdFormatGetData, FaCheckData, FaCheckError, FaCheckResponse, UserLoginData, UserLoginError, LogoutData, LogoutError, ApiBatchesFormatGetCollectionData, ApiBatchesFormatGetCollectionResponse, ApiBatchesBatchIdFormatGetData, ApiBinlookupsuploadFormatPostData, ApiBinlookupsuploadFormatPostError, ApiBinlookupsuploadFormatPostResponse, ApiCardTokensTokenFormatGetData, ApiCheckTokensTokenFormatGetData, ApiCustomerAddressAuditsFormatGetCollectionData, ApiCustomerAddressAuditsFormatGetCollectionError, ApiCustomerAddressAuditsFormatGetCollectionResponse, ApiCustomersFormatGetCollectionData, ApiCustomersFormatGetCollectionError, ApiCustomersFormatGetCollectionResponse, ApiCustomersFormatPostData, ApiCustomersFormatPostError, ApiCustomersFormatPostResponse, ApiCustomersIdFormatGetData, ApiCustomersIdFormatPatchData, ApiCustomersIdFormatPatchError, ApiCustomersIdFormatPatchResponse, ApiUsersmemfaProvidersProviderFormatGetData, ApiCustomersinvoicesIdpayFormatPostData, ApiCustomersinvoicesIdpayFormatPostError, ApiCustomersinvoicesIdpayFormatPostResponse, ApiInvoicesFormatGetCollectionData, ApiInvoicesFormatGetCollectionResponse, ApiInvoicesFormatPostData, ApiInvoicesFormatPostError, ApiInvoicesFormatPostResponse, ApiInvoicesclosedIdFormatPatchData, ApiInvoicesclosedIdFormatPatchError, ApiInvoicesdownloadIdGetData, ApiInvoicesexportGetCollectionData, ApiInvoicespayIdFormatPostData, ApiInvoicespayIdFormatPostError, ApiInvoicespayIdFormatPostResponse, ApiInvoicespreviewFormatPostData, ApiInvoicespreviewFormatPostError, ApiInvoicespreviewFormatPostResponse, ApiInvoicespublicIdFormatGetData, ApiInvoicesresendIdFormatPostData, ApiInvoicesresendIdFormatPostError, ApiInvoicesIdFormatGetData, ApiInvoicesIdFormatPatchData, ApiInvoicesIdFormatPatchError, ApiInvoicesIdFormatPatchResponse, ApiMerchantDefinedFieldsFormatGetCollectionData, ApiMerchantDefinedFieldsFormatGetCollectionResponse, ApiMerchantDefinedFieldsFormatPostData, ApiMerchantDefinedFieldsFormatPostError, ApiMerchantDefinedFieldsFormatPostResponse, ApiMerchantDefinedFieldsIdFormatDeleteData, ApiMerchantDefinedFieldsIdFormatDeleteError, ApiMerchantDefinedFieldsIdFormatDeleteResponse, ApiMerchantDefinedFieldsIdFormatGetData, ApiMerchantDefinedFieldsIdFormatPatchData, ApiMerchantDefinedFieldsIdFormatPatchError, ApiMerchantDefinedFieldsIdFormatPatchResponse, ApiMerchantsFormatGetCollectionData, ApiMerchantsFormatGetCollectionResponse, ApiMerchantsFormatPostData, ApiMerchantsFormatPostError, ApiMerchantsFormatPostResponse, ApiMerchantsMerchAccountIdFormatDeleteData, ApiMerchantsMerchAccountIdFormatDeleteError, ApiMerchantsMerchAccountIdFormatDeleteResponse, ApiMerchantsMerchAccountIdFormatGetData, ApiMerchantsMerchAccountIdFormatPatchData, ApiMerchantsMerchAccountIdFormatPatchError, ApiMerchantsMerchAccountIdFormatPatchResponse, ApiObjectFilesFormatGetCollectionData, ApiObjectFilesFormatGetCollectionResponse, ApiObjectFilesFormatPostData, ApiObjectFilesFormatPostError, ApiObjectFilesFormatPostResponse, ApiPaymentsIdFormatGetData, ApiProductCategoriesFormatGetCollectionData, ApiProductCategoriesFormatGetCollectionResponse, ApiProductCategoriesFormatPostData, ApiProductCategoriesFormatPostError, ApiProductCategoriesFormatPostResponse, ApiProductCategoriesIdFormatDeleteData, ApiProductCategoriesIdFormatDeleteError, ApiProductCategoriesIdFormatDeleteResponse, ApiProductCategoriesIdFormatGetData, ApiProductCategoriesIdFormatPatchData, ApiProductCategoriesIdFormatPatchError, ApiProductDetailByLocationFormatGetCollectionData, ApiProductDetailByLocationFormatGetCollectionResponse, ApiProductDetailByLocationFormatPostData, ApiProductDetailByLocationFormatPostError, ApiProductDetailByLocationFormatPostResponse, ApiProductDetailByLocationIdFormatDeleteData, ApiProductDetailByLocationIdFormatDeleteError, ApiProductDetailByLocationIdFormatDeleteResponse, ApiProductDetailByLocationIdFormatGetData, ApiProductDetailByLocationIdFormatPatchData, ApiProductDetailByLocationIdFormatPatchError, ApiProductLocationsFormatGetCollectionData, ApiProductLocationsFormatGetCollectionResponse, ApiProductLocationsFormatPostData, ApiProductLocationsFormatPostError, ApiProductLocationsFormatPostResponse, ApiProductLocationsIdFormatDeleteData, ApiProductLocationsIdFormatDeleteError, ApiProductLocationsIdFormatDeleteResponse, ApiProductLocationsIdFormatGetData, ApiProductLocationsIdFormatPatchData, ApiProductLocationsIdFormatPatchError, ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionData, ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionResponse, ApiProductPackagesFormatGetCollectionData, ApiProductPackagesFormatGetCollectionResponse, ApiProductPackagesFormatPostData, ApiProductPackagesFormatPostError, ApiProductPackagesIdFormatDeleteData, ApiProductPackagesIdFormatDeleteError, ApiProductPackagesIdFormatDeleteResponse, ApiProductPackagesIdFormatGetData, ApiProductPackagesIdFormatPatchData, ApiProductPackagesIdFormatPatchError, ApiProductStockOrderItemsStockOrderIdFormatGetCollectionData, ApiProductStockOrderItemsStockOrderIdFormatGetCollectionResponse, ApiProductStockOrderStatusIdFormatPatchData, ApiProductStockOrderStatusIdFormatPatchError, ApiProductStockOrdersFormatGetCollectionData, ApiProductStockOrdersFormatGetCollectionResponse, ApiProductStockOrdersFormatPostData, ApiProductStockOrdersFormatPostError, ApiProductStockOrdersFormatPostResponse, ApiProductStockOrdersIdFormatDeleteData, ApiProductStockOrdersIdFormatDeleteError, ApiProductStockOrdersIdFormatDeleteResponse, ApiProductStockOrdersIdFormatGetData, ApiProductStockOrdersIdFormatPatchData, ApiProductStockOrdersIdFormatPatchError, ApiProductsFormatGetCollectionData, ApiProductsFormatGetCollectionResponse, ApiProductsFormatPostData, ApiProductsFormatPostError, ApiProductsFormatPostResponse, ApiProductsIdFormatDeleteData, ApiProductsIdFormatDeleteError, ApiProductsIdFormatDeleteResponse, ApiProductsIdFormatGetData, ApiProductsIdFormatPatchData, ApiProductsIdFormatPatchError, ApiPlansFormatGetCollectionData, ApiPlansFormatGetCollectionResponse, ApiPlansFormatPostData, ApiPlansFormatPostError, ApiPlansFormatPostResponse, ApiPlansIdFormatDeleteData, ApiPlansIdFormatDeleteError, ApiPlansIdFormatDeleteResponse, ApiPlansIdFormatGetData, ApiPlansIdFormatPatchData, ApiPlansIdFormatPatchError, ApiRecurStatusRecurIdFormatPatchData, ApiRecurStatusRecurIdFormatPatchError, ApiRecursFormatGetCollectionData, ApiRecursFormatGetCollectionResponse, ApiRecursFormatPostData, ApiRecursFormatPostError, ApiRecursFormatPostResponse, ApiRecursIdFormatDeleteData, ApiRecursIdFormatDeleteError, ApiRecursIdFormatDeleteResponse, ApiRecursIdFormatGetData, ApiRecursIdFormatPatchData, ApiRecursIdFormatPatchError, ApiTransactionSignatureIdFormatGetData, ApiBatchesreopenBatchIdFormatPostData, ApiBatchesreopenBatchIdFormatPostError, ApiManagebdkFormatGetCollectionData, ApiManagebdkFormatGetCollectionError, ApiManagebdkFormatGetCollectionResponse, ApiManagebdkFormatPostData, ApiManagebdkFormatPostError, ApiManagebdkIdFormatDeleteData, ApiManagebdkIdFormatDeleteError, ApiManagebdkIdFormatDeleteResponse, ApiManagebdkIdFormatGetData, ApiManagebdkIdFormatPatchData, ApiManagebdkIdFormatPatchError, ApiTransactionsallFormatGetCollectionData, ApiTransactionsallFormatGetCollectionResponse, ApiTransactionsauthToSaleFormatPostData, ApiTransactionsauthToSaleFormatPostError, ApiTransactionsauthToSaleFormatPostResponse, ApiTransactionsbatchCloseFormatPostData, ApiTransactionsbatchCloseFormatPostError, ApiTransactionsbatchCloseFormatPostResponse, ApiTransactionsbatchedFormatGetCollectionData, ApiTransactionsbatchedFormatGetCollectionResponse, ApiTransactionsbatchedTransactionIdFormatGetData, ApiTransactionsblindReturnFormatPostData, ApiTransactionsblindReturnFormatPostError, ApiTransactionsblindReturnFormatPostResponse, ApiTransactionscheckStoreFormatPostData, ApiTransactionscheckStoreFormatPostError, ApiTransactionscheckStoreFormatPostResponse, ApiTransactionsdeclinedFormatGetCollectionData, ApiTransactionsdeclinedFormatGetCollectionResponse, ApiTransactionsdeclinedTransactionIdFormatGetData, ApiTransactionserrorFormatGetCollectionData, ApiTransactionserrorFormatGetCollectionResponse, ApiTransactionserrorTransactionIdFormatGetData, ApiTransactionsincrementalFormatPostData, ApiTransactionsincrementalFormatPostError, ApiTransactionsincrementalFormatPostResponse, ApiTransactionsreEnterFormatPostData, ApiTransactionsreEnterFormatPostError, ApiTransactionsreEnterFormatPostResponse, ApiTransactionsreturnFormatPostData, ApiTransactionsreturnFormatPostError, ApiTransactionsreturnFormatPostResponse, ApiTransactionsreversalFormatPostData, ApiTransactionsreversalFormatPostError, ApiTransactionsreversalFormatPostResponse, ApiTransactionssaleFormatPostData, ApiTransactionssaleFormatPostError, ApiTransactionssaleFormatPostResponse, ApiTransactionssettledFormatGetCollectionData, ApiTransactionssettledFormatGetCollectionResponse, ApiTransactionssettledTransactionIdFormatGetData, ApiTransactionsstoreFormatPostData, ApiTransactionsstoreFormatPostError, ApiTransactionsstoreFormatPostResponse, ApiTransactionsvoidFormatPostData, ApiTransactionsvoidFormatPostError, ApiTransactionsvoidFormatPostResponse, ApiTransactionsTransactionIdreceiptFormatGetData, ApiUsersFormatGetCollectionData, ApiUsersFormatGetCollectionError, ApiUsersFormatGetCollectionResponse, ApiUsersPostData, ApiUsersPostError, ApiUsersmeFormatGetData, ApiUsersmechangePasswordFormatPatchData, ApiUsersmechangePasswordFormatPatchError, ApiUsersmedisableMfaFormatPatchData, ApiUsersmedisableMfaFormatPatchError, ApiUsersmegenerateMfaBackupCodesFormatPostData, ApiUsersmegenerateMfaBackupCodesFormatPostError, ApiUsersmegenerateMfaBackupCodesFormatPostResponse, ApiUsersmegenerateMfaEmailAuthCodeFormatPostData, ApiUsersmegenerateMfaEmailAuthCodeFormatPostError, ApiUsersmegenerateMfaGoogleTotpFormatPostData, ApiUsersmegenerateMfaGoogleTotpFormatPostError, ApiUsersmegenerateMfaGoogleTotpFormatPostResponse, ApiUsersmemfaProvidersFormatGetCollectionData, ApiUsersmemfaProvidersFormatPostData, ApiUsersmemfaProvidersFormatPostError, ApiUsersmepreferMfaFormatPatchData, ApiUsersmepreferMfaFormatPatchError, ApiUsersmesetupMfaEmailAuthCodeFormatPostData, ApiUsersmesetupMfaEmailAuthCodeFormatPostError, ApiUsersmesetupMfaGoogleTotpFormatPostData, ApiUsersmesetupMfaGoogleTotpFormatPostError, ApiUsersrequestResetPasswordFormatPostData, ApiUsersrequestResetPasswordFormatPostError, ApiUsersresetMfaAccountIdFormatPatchData, ApiUsersresetMfaAccountIdFormatPatchError, ApiUsersresetPasswordFormatPostData, ApiUsersresetPasswordFormatPostError, ApiUsersresetPasswordIdFormatGetData, ApiUsersIdDeleteData, ApiUsersIdDeleteError, ApiUsersIdDeleteResponse, ApiUsersIdFormatGetData, ApiUsersIdFormatPatchData, ApiUsersIdFormatPatchError } from '../types.gen';
import type { AxiosError } from 'axios';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseURL: (options?.client ?? _heyApiClient).getConfig().baseURL } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const apiAddressesFormatPostQueryKey = (options: Options<ApiAddressesFormatPostData>) => createQueryKey('apiAddressesFormatPost', options);

/**
 * Create new address
 * Creates a PostAddressResource resource.
 */
export const apiAddressesFormatPostOptions = (options: Options<ApiAddressesFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiAddressesFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiAddressesFormatPostQueryKey(options)
    });
};

/**
 * Create new address
 * Creates a PostAddressResource resource.
 */
export const apiAddressesFormatPostMutation = (options?: Partial<Options<ApiAddressesFormatPostData>>): UseMutationOptions<ApiAddressesFormatPostResponse, AxiosError<ApiAddressesFormatPostError>, Options<ApiAddressesFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiAddressesFormatPostResponse, AxiosError<ApiAddressesFormatPostError>, Options<ApiAddressesFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiAddressesFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiAddressesIdFormatGetQueryKey = (options: Options<ApiAddressesIdFormatGetData>) => createQueryKey('apiAddressesIdFormatGet', options);

/**
 * Get a single address by customer_id and address_id.
 * Retrieves a Address resource.
 */
export const apiAddressesIdFormatGetOptions = (options: Options<ApiAddressesIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiAddressesIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiAddressesIdFormatGetQueryKey(options)
    });
};

/**
 * Update a address
 * Updates the PatchAddressResource resource.
 */
export const apiAddressesIdFormatPatchMutation = (options?: Partial<Options<ApiAddressesIdFormatPatchData>>): UseMutationOptions<ApiAddressesIdFormatPatchResponse, AxiosError<ApiAddressesIdFormatPatchError>, Options<ApiAddressesIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<ApiAddressesIdFormatPatchResponse, AxiosError<ApiAddressesIdFormatPatchError>, Options<ApiAddressesIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiAddressesIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiBinlookupsFormatGetCollectionQueryKey = (options?: Options<ApiBinlookupsFormatGetCollectionData>) => createQueryKey('apiBinlookupsFormatGetCollection', options);

/**
 * Retrieves the collection of BinRanges resources.
 * Retrieves the collection of BinRanges resources.
 */
export const apiBinlookupsFormatGetCollectionOptions = (options?: Options<ApiBinlookupsFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiBinlookupsFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiBinlookupsFormatGetCollectionQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = {
        ...queryKey[0]
    };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const apiBinlookupsFormatGetCollectionInfiniteQueryKey = (options?: Options<ApiBinlookupsFormatGetCollectionData>): QueryKey<Options<ApiBinlookupsFormatGetCollectionData>> => createQueryKey('apiBinlookupsFormatGetCollection', options, true);

/**
 * Retrieves the collection of BinRanges resources.
 * Retrieves the collection of BinRanges resources.
 */
export const apiBinlookupsFormatGetCollectionInfiniteOptions = (options?: Options<ApiBinlookupsFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiBinlookupsFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiBinlookupsFormatGetCollectionResponse>, QueryKey<Options<ApiBinlookupsFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiBinlookupsFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiBinlookupsFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiBinlookupsFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiBinlookupsFormatGetCollectionInfiniteQueryKey(options)
    });
};

/**
 * Removes the BinRanges resource.
 * Removes the BinRanges resource.
 */
export const apiBinlookupsBinFormatDeleteMutation = (options?: Partial<Options<ApiBinlookupsBinFormatDeleteData>>): UseMutationOptions<ApiBinlookupsBinFormatDeleteResponse, AxiosError<ApiBinlookupsBinFormatDeleteError>, Options<ApiBinlookupsBinFormatDeleteData>> => {
    const mutationOptions: UseMutationOptions<ApiBinlookupsBinFormatDeleteResponse, AxiosError<ApiBinlookupsBinFormatDeleteError>, Options<ApiBinlookupsBinFormatDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiBinlookupsBinFormatDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiBinlookupsBinFormatGetQueryKey = (options: Options<ApiBinlookupsBinFormatGetData>) => createQueryKey('apiBinlookupsBinFormatGet', options);

/**
 * Retrieves a BinRanges resource.
 * Retrieves a BinRanges resource.
 */
export const apiBinlookupsBinFormatGetOptions = (options: Options<ApiBinlookupsBinFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiBinlookupsBinFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiBinlookupsBinFormatGetQueryKey(options)
    });
};

export const apiTransactionSignatureFormatPostQueryKey = (options: Options<ApiTransactionSignatureFormatPostData>) => createQueryKey('apiTransactionSignatureFormatPost', options);

/**
 * Create new signature.
 * # Create new signature.
 */
export const apiTransactionSignatureFormatPostOptions = (options: Options<ApiTransactionSignatureFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionSignatureFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionSignatureFormatPostQueryKey(options)
    });
};

/**
 * Create new signature.
 * # Create new signature.
 */
export const apiTransactionSignatureFormatPostMutation = (options?: Partial<Options<ApiTransactionSignatureFormatPostData>>): UseMutationOptions<ApiTransactionSignatureFormatPostResponse, AxiosError<ApiTransactionSignatureFormatPostError>, Options<ApiTransactionSignatureFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiTransactionSignatureFormatPostResponse, AxiosError<ApiTransactionSignatureFormatPostError>, Options<ApiTransactionSignatureFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiTransactionSignatureFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiTransactionsauthorizedFormatGetCollectionQueryKey = (options: Options<ApiTransactionsauthorizedFormatGetCollectionData>) => createQueryKey('apiTransactionsauthorizedFormatGetCollection', options);

/**
 * Retrieves the collection of AuthorizedTransaction resources.
 * Retrieves the collection of AuthorizedTransaction resources.
 */
export const apiTransactionsauthorizedFormatGetCollectionOptions = (options: Options<ApiTransactionsauthorizedFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsauthorizedFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsauthorizedFormatGetCollectionQueryKey(options)
    });
};

export const apiTransactionsauthorizedFormatGetCollectionInfiniteQueryKey = (options: Options<ApiTransactionsauthorizedFormatGetCollectionData>): QueryKey<Options<ApiTransactionsauthorizedFormatGetCollectionData>> => createQueryKey('apiTransactionsauthorizedFormatGetCollection', options, true);

/**
 * Retrieves the collection of AuthorizedTransaction resources.
 * Retrieves the collection of AuthorizedTransaction resources.
 */
export const apiTransactionsauthorizedFormatGetCollectionInfiniteOptions = (options: Options<ApiTransactionsauthorizedFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiTransactionsauthorizedFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiTransactionsauthorizedFormatGetCollectionResponse>, QueryKey<Options<ApiTransactionsauthorizedFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiTransactionsauthorizedFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiTransactionsauthorizedFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiTransactionsauthorizedFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsauthorizedFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiTransactionsauthorizedTransactionIdFormatGetQueryKey = (options: Options<ApiTransactionsauthorizedTransactionIdFormatGetData>) => createQueryKey('apiTransactionsauthorizedTransactionIdFormatGet', options);

/**
 * Retrieves a AuthorizedTransaction resource.
 * Retrieves a AuthorizedTransaction resource.
 */
export const apiTransactionsauthorizedTransactionIdFormatGetOptions = (options: Options<ApiTransactionsauthorizedTransactionIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsauthorizedTransactionIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsauthorizedTransactionIdFormatGetQueryKey(options)
    });
};

export const faCheckQueryKey = (options: Options<FaCheckData>) => createQueryKey('faCheck', options);

/**
 * MFA check
 * Checking MFA after user logged in
 */
export const faCheckOptions = (options: Options<FaCheckData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await faCheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: faCheckQueryKey(options)
    });
};

/**
 * MFA check
 * Checking MFA after user logged in
 */
export const faCheckMutation = (options?: Partial<Options<FaCheckData>>): UseMutationOptions<FaCheckResponse, AxiosError<FaCheckError>, Options<FaCheckData>> => {
    const mutationOptions: UseMutationOptions<FaCheckResponse, AxiosError<FaCheckError>, Options<FaCheckData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await faCheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userLoginQueryKey = (options: Options<UserLoginData>) => createQueryKey('userLogin', options);

/**
 * User login
 * User login to the system
 */
export const userLoginOptions = (options: Options<UserLoginData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await userLogin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: userLoginQueryKey(options)
    });
};

/**
 * User login
 * User login to the system
 */
export const userLoginMutation = (options?: Partial<Options<UserLoginData>>): UseMutationOptions<unknown, AxiosError<UserLoginError>, Options<UserLoginData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<UserLoginError>, Options<UserLoginData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await userLogin({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const logoutQueryKey = (options?: Options<LogoutData>) => createQueryKey('logout', options);

/**
 * User logout
 * User logout from the system
 */
export const logoutOptions = (options?: Options<LogoutData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await logout({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: logoutQueryKey(options)
    });
};

/**
 * User logout
 * User logout from the system
 */
export const logoutMutation = (options?: Partial<Options<LogoutData>>): UseMutationOptions<unknown, AxiosError<LogoutError>, Options<LogoutData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<LogoutError>, Options<LogoutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await logout({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiBatchesFormatGetCollectionQueryKey = (options: Options<ApiBatchesFormatGetCollectionData>) => createQueryKey('apiBatchesFormatGetCollection', options);

/**
 * Get all batches
 * Retrieves the collection of Batch resources.
 */
export const apiBatchesFormatGetCollectionOptions = (options: Options<ApiBatchesFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiBatchesFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiBatchesFormatGetCollectionQueryKey(options)
    });
};

export const apiBatchesFormatGetCollectionInfiniteQueryKey = (options: Options<ApiBatchesFormatGetCollectionData>): QueryKey<Options<ApiBatchesFormatGetCollectionData>> => createQueryKey('apiBatchesFormatGetCollection', options, true);

/**
 * Get all batches
 * Retrieves the collection of Batch resources.
 */
export const apiBatchesFormatGetCollectionInfiniteOptions = (options: Options<ApiBatchesFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiBatchesFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiBatchesFormatGetCollectionResponse>, QueryKey<Options<ApiBatchesFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiBatchesFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiBatchesFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiBatchesFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiBatchesFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiBatchesBatchIdFormatGetQueryKey = (options: Options<ApiBatchesBatchIdFormatGetData>) => createQueryKey('apiBatchesBatchIdFormatGet', options);

/**
 * Get batch detail by batch id
 * Retrieves a Batch resource.
 */
export const apiBatchesBatchIdFormatGetOptions = (options: Options<ApiBatchesBatchIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiBatchesBatchIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiBatchesBatchIdFormatGetQueryKey(options)
    });
};

export const apiBinlookupsuploadFormatPostQueryKey = (options?: Options<ApiBinlookupsuploadFormatPostData>) => createQueryKey('apiBinlookupsuploadFormatPost', options);

/**
 * Creates a PostBinUploadResource resource.
 * Creates a PostBinUploadResource resource.
 */
export const apiBinlookupsuploadFormatPostOptions = (options?: Options<ApiBinlookupsuploadFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiBinlookupsuploadFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiBinlookupsuploadFormatPostQueryKey(options)
    });
};

/**
 * Creates a PostBinUploadResource resource.
 * Creates a PostBinUploadResource resource.
 */
export const apiBinlookupsuploadFormatPostMutation = (options?: Partial<Options<ApiBinlookupsuploadFormatPostData>>): UseMutationOptions<ApiBinlookupsuploadFormatPostResponse, AxiosError<ApiBinlookupsuploadFormatPostError>, Options<ApiBinlookupsuploadFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiBinlookupsuploadFormatPostResponse, AxiosError<ApiBinlookupsuploadFormatPostError>, Options<ApiBinlookupsuploadFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiBinlookupsuploadFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiCardTokensTokenFormatGetQueryKey = (options: Options<ApiCardTokensTokenFormatGetData>) => createQueryKey('apiCardTokensTokenFormatGet', options);

/**
 * Retrieves a CardStore resource.
 * Retrieves a CardStore resource.
 */
export const apiCardTokensTokenFormatGetOptions = (options: Options<ApiCardTokensTokenFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiCardTokensTokenFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiCardTokensTokenFormatGetQueryKey(options)
    });
};

export const apiCheckTokensTokenFormatGetQueryKey = (options: Options<ApiCheckTokensTokenFormatGetData>) => createQueryKey('apiCheckTokensTokenFormatGet', options);

/**
 * Retrieves a CheckStore resource.
 * Retrieves a CheckStore resource.
 */
export const apiCheckTokensTokenFormatGetOptions = (options: Options<ApiCheckTokensTokenFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiCheckTokensTokenFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiCheckTokensTokenFormatGetQueryKey(options)
    });
};

export const apiCustomerAddressAuditsFormatGetCollectionQueryKey = (options: Options<ApiCustomerAddressAuditsFormatGetCollectionData>) => createQueryKey('apiCustomerAddressAuditsFormatGetCollection', options);

/**
 * Get all customer address audits
 * Retrieves the collection of CustomerAddressAudit resources.
 */
export const apiCustomerAddressAuditsFormatGetCollectionOptions = (options: Options<ApiCustomerAddressAuditsFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiCustomerAddressAuditsFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiCustomerAddressAuditsFormatGetCollectionQueryKey(options)
    });
};

export const apiCustomerAddressAuditsFormatGetCollectionInfiniteQueryKey = (options: Options<ApiCustomerAddressAuditsFormatGetCollectionData>): QueryKey<Options<ApiCustomerAddressAuditsFormatGetCollectionData>> => createQueryKey('apiCustomerAddressAuditsFormatGetCollection', options, true);

/**
 * Get all customer address audits
 * Retrieves the collection of CustomerAddressAudit resources.
 */
export const apiCustomerAddressAuditsFormatGetCollectionInfiniteOptions = (options: Options<ApiCustomerAddressAuditsFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiCustomerAddressAuditsFormatGetCollectionResponse, AxiosError<ApiCustomerAddressAuditsFormatGetCollectionError>, InfiniteData<ApiCustomerAddressAuditsFormatGetCollectionResponse>, QueryKey<Options<ApiCustomerAddressAuditsFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiCustomerAddressAuditsFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiCustomerAddressAuditsFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiCustomerAddressAuditsFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiCustomerAddressAuditsFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiCustomersFormatGetCollectionQueryKey = (options: Options<ApiCustomersFormatGetCollectionData>) => createQueryKey('apiCustomersFormatGetCollection', options);

/**
 * Get all customers
 * Retrieves the collection of Customer resources.
 */
export const apiCustomersFormatGetCollectionOptions = (options: Options<ApiCustomersFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiCustomersFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiCustomersFormatGetCollectionQueryKey(options)
    });
};

export const apiCustomersFormatGetCollectionInfiniteQueryKey = (options: Options<ApiCustomersFormatGetCollectionData>): QueryKey<Options<ApiCustomersFormatGetCollectionData>> => createQueryKey('apiCustomersFormatGetCollection', options, true);

/**
 * Get all customers
 * Retrieves the collection of Customer resources.
 */
export const apiCustomersFormatGetCollectionInfiniteOptions = (options: Options<ApiCustomersFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiCustomersFormatGetCollectionResponse, AxiosError<ApiCustomersFormatGetCollectionError>, InfiniteData<ApiCustomersFormatGetCollectionResponse>, QueryKey<Options<ApiCustomersFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiCustomersFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiCustomersFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiCustomersFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiCustomersFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiCustomersFormatPostQueryKey = (options: Options<ApiCustomersFormatPostData>) => createQueryKey('apiCustomersFormatPost', options);

/**
 * Create new customer
 * Creates a PostCustomerResource resource.
 */
export const apiCustomersFormatPostOptions = (options: Options<ApiCustomersFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiCustomersFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiCustomersFormatPostQueryKey(options)
    });
};

/**
 * Create new customer
 * Creates a PostCustomerResource resource.
 */
export const apiCustomersFormatPostMutation = (options?: Partial<Options<ApiCustomersFormatPostData>>): UseMutationOptions<ApiCustomersFormatPostResponse, AxiosError<ApiCustomersFormatPostError>, Options<ApiCustomersFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiCustomersFormatPostResponse, AxiosError<ApiCustomersFormatPostError>, Options<ApiCustomersFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiCustomersFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiCustomersIdFormatGetQueryKey = (options: Options<ApiCustomersIdFormatGetData>) => createQueryKey('apiCustomersIdFormatGet', options);

/**
 * Get a single customer
 * Retrieves a Customer resource.
 */
export const apiCustomersIdFormatGetOptions = (options: Options<ApiCustomersIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiCustomersIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiCustomersIdFormatGetQueryKey(options)
    });
};

/**
 * Update a customer
 * Updates the PatchCustomerResource resource.
 */
export const apiCustomersIdFormatPatchMutation = (options?: Partial<Options<ApiCustomersIdFormatPatchData>>): UseMutationOptions<ApiCustomersIdFormatPatchResponse, AxiosError<ApiCustomersIdFormatPatchError>, Options<ApiCustomersIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<ApiCustomersIdFormatPatchResponse, AxiosError<ApiCustomersIdFormatPatchError>, Options<ApiCustomersIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiCustomersIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiUsersmemfaProvidersProviderFormatGetQueryKey = (options: Options<ApiUsersmemfaProvidersProviderFormatGetData>) => createQueryKey('apiUsersmemfaProvidersProviderFormatGet', options);

/**
 * Retrieves a GetMfaProviderResource resource.
 * Retrieves a GetMfaProviderResource resource.
 */
export const apiUsersmemfaProvidersProviderFormatGetOptions = (options: Options<ApiUsersmemfaProvidersProviderFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersmemfaProvidersProviderFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersmemfaProvidersProviderFormatGetQueryKey(options)
    });
};

export const apiCustomersinvoicesIdpayFormatPostQueryKey = (options: Options<ApiCustomersinvoicesIdpayFormatPostData>) => createQueryKey('apiCustomersinvoicesIdpayFormatPost', options);

/**
 * Pay an invoice.
 * # Pay an invoice.
 */
export const apiCustomersinvoicesIdpayFormatPostOptions = (options: Options<ApiCustomersinvoicesIdpayFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiCustomersinvoicesIdpayFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiCustomersinvoicesIdpayFormatPostQueryKey(options)
    });
};

/**
 * Pay an invoice.
 * # Pay an invoice.
 */
export const apiCustomersinvoicesIdpayFormatPostMutation = (options?: Partial<Options<ApiCustomersinvoicesIdpayFormatPostData>>): UseMutationOptions<ApiCustomersinvoicesIdpayFormatPostResponse, AxiosError<ApiCustomersinvoicesIdpayFormatPostError>, Options<ApiCustomersinvoicesIdpayFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiCustomersinvoicesIdpayFormatPostResponse, AxiosError<ApiCustomersinvoicesIdpayFormatPostError>, Options<ApiCustomersinvoicesIdpayFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiCustomersinvoicesIdpayFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiInvoicesFormatGetCollectionQueryKey = (options: Options<ApiInvoicesFormatGetCollectionData>) => createQueryKey('apiInvoicesFormatGetCollection', options);

/**
 * Retrieves the collection of Invoice resources.
 * Retrieves the collection of Invoice resources.
 */
export const apiInvoicesFormatGetCollectionOptions = (options: Options<ApiInvoicesFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiInvoicesFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiInvoicesFormatGetCollectionQueryKey(options)
    });
};

export const apiInvoicesFormatGetCollectionInfiniteQueryKey = (options: Options<ApiInvoicesFormatGetCollectionData>): QueryKey<Options<ApiInvoicesFormatGetCollectionData>> => createQueryKey('apiInvoicesFormatGetCollection', options, true);

/**
 * Retrieves the collection of Invoice resources.
 * Retrieves the collection of Invoice resources.
 */
export const apiInvoicesFormatGetCollectionInfiniteOptions = (options: Options<ApiInvoicesFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiInvoicesFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiInvoicesFormatGetCollectionResponse>, QueryKey<Options<ApiInvoicesFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiInvoicesFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiInvoicesFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiInvoicesFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiInvoicesFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiInvoicesFormatPostQueryKey = (options: Options<ApiInvoicesFormatPostData>) => createQueryKey('apiInvoicesFormatPost', options);

/**
 * Create an invoice.
 * # Create an invoice.
 */
export const apiInvoicesFormatPostOptions = (options: Options<ApiInvoicesFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiInvoicesFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiInvoicesFormatPostQueryKey(options)
    });
};

/**
 * Create an invoice.
 * # Create an invoice.
 */
export const apiInvoicesFormatPostMutation = (options?: Partial<Options<ApiInvoicesFormatPostData>>): UseMutationOptions<ApiInvoicesFormatPostResponse, AxiosError<ApiInvoicesFormatPostError>, Options<ApiInvoicesFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiInvoicesFormatPostResponse, AxiosError<ApiInvoicesFormatPostError>, Options<ApiInvoicesFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiInvoicesFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Close an invoice.
 * Updates the CloseInvoiceResource resource.
 */
export const apiInvoicesclosedIdFormatPatchMutation = (options?: Partial<Options<ApiInvoicesclosedIdFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiInvoicesclosedIdFormatPatchError>, Options<ApiInvoicesclosedIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiInvoicesclosedIdFormatPatchError>, Options<ApiInvoicesclosedIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiInvoicesclosedIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiInvoicesdownloadIdGetQueryKey = (options: Options<ApiInvoicesdownloadIdGetData>) => createQueryKey('apiInvoicesdownloadIdGet', options);

/**
 * Download an invoice.
 * Retrieves a Invoice resource.
 */
export const apiInvoicesdownloadIdGetOptions = (options: Options<ApiInvoicesdownloadIdGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiInvoicesdownloadIdGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiInvoicesdownloadIdGetQueryKey(options)
    });
};

export const apiInvoicesexportGetCollectionQueryKey = (options: Options<ApiInvoicesexportGetCollectionData>) => createQueryKey('apiInvoicesexportGetCollection', options);

/**
 * Export list of invoices
 * Retrieves the collection of Invoice resources.
 */
export const apiInvoicesexportGetCollectionOptions = (options: Options<ApiInvoicesexportGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiInvoicesexportGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiInvoicesexportGetCollectionQueryKey(options)
    });
};

export const apiInvoicespayIdFormatPostQueryKey = (options: Options<ApiInvoicespayIdFormatPostData>) => createQueryKey('apiInvoicespayIdFormatPost', options);

/**
 * Pay an invoice.
 * # Pay an invoice.
 */
export const apiInvoicespayIdFormatPostOptions = (options: Options<ApiInvoicespayIdFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiInvoicespayIdFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiInvoicespayIdFormatPostQueryKey(options)
    });
};

/**
 * Pay an invoice.
 * # Pay an invoice.
 */
export const apiInvoicespayIdFormatPostMutation = (options?: Partial<Options<ApiInvoicespayIdFormatPostData>>): UseMutationOptions<ApiInvoicespayIdFormatPostResponse, AxiosError<ApiInvoicespayIdFormatPostError>, Options<ApiInvoicespayIdFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiInvoicespayIdFormatPostResponse, AxiosError<ApiInvoicespayIdFormatPostError>, Options<ApiInvoicespayIdFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiInvoicespayIdFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiInvoicespreviewFormatPostQueryKey = (options: Options<ApiInvoicespreviewFormatPostData>) => createQueryKey('apiInvoicespreviewFormatPost', options);

/**
 * Preview a invoice.
 * # Preview a invoice.
 */
export const apiInvoicespreviewFormatPostOptions = (options: Options<ApiInvoicespreviewFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiInvoicespreviewFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiInvoicespreviewFormatPostQueryKey(options)
    });
};

/**
 * Preview a invoice.
 * # Preview a invoice.
 */
export const apiInvoicespreviewFormatPostMutation = (options?: Partial<Options<ApiInvoicespreviewFormatPostData>>): UseMutationOptions<ApiInvoicespreviewFormatPostResponse, AxiosError<ApiInvoicespreviewFormatPostError>, Options<ApiInvoicespreviewFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiInvoicespreviewFormatPostResponse, AxiosError<ApiInvoicespreviewFormatPostError>, Options<ApiInvoicespreviewFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiInvoicespreviewFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiInvoicespublicIdFormatGetQueryKey = (options: Options<ApiInvoicespublicIdFormatGetData>) => createQueryKey('apiInvoicespublicIdFormatGet', options);

/**
 * Get invoice by ID for customer
 * Retrieves a Invoice resource.
 */
export const apiInvoicespublicIdFormatGetOptions = (options: Options<ApiInvoicespublicIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiInvoicespublicIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiInvoicespublicIdFormatGetQueryKey(options)
    });
};

export const apiInvoicesresendIdFormatPostQueryKey = (options: Options<ApiInvoicesresendIdFormatPostData>) => createQueryKey('apiInvoicesresendIdFormatPost', options);

/**
 * Resend an invoice.
 * Creates a ResendInvoiceResource resource.
 */
export const apiInvoicesresendIdFormatPostOptions = (options: Options<ApiInvoicesresendIdFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiInvoicesresendIdFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiInvoicesresendIdFormatPostQueryKey(options)
    });
};

/**
 * Resend an invoice.
 * Creates a ResendInvoiceResource resource.
 */
export const apiInvoicesresendIdFormatPostMutation = (options?: Partial<Options<ApiInvoicesresendIdFormatPostData>>): UseMutationOptions<unknown, AxiosError<ApiInvoicesresendIdFormatPostError>, Options<ApiInvoicesresendIdFormatPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiInvoicesresendIdFormatPostError>, Options<ApiInvoicesresendIdFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiInvoicesresendIdFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiInvoicesIdFormatGetQueryKey = (options: Options<ApiInvoicesIdFormatGetData>) => createQueryKey('apiInvoicesIdFormatGet', options);

/**
 * Get invoice by ID
 * Retrieves a Invoice resource.
 */
export const apiInvoicesIdFormatGetOptions = (options: Options<ApiInvoicesIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiInvoicesIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiInvoicesIdFormatGetQueryKey(options)
    });
};

/**
 * Update an invoice.
 * # Update an invoice.
 */
export const apiInvoicesIdFormatPatchMutation = (options?: Partial<Options<ApiInvoicesIdFormatPatchData>>): UseMutationOptions<ApiInvoicesIdFormatPatchResponse, AxiosError<ApiInvoicesIdFormatPatchError>, Options<ApiInvoicesIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<ApiInvoicesIdFormatPatchResponse, AxiosError<ApiInvoicesIdFormatPatchError>, Options<ApiInvoicesIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiInvoicesIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiMerchantDefinedFieldsFormatGetCollectionQueryKey = (options: Options<ApiMerchantDefinedFieldsFormatGetCollectionData>) => createQueryKey('apiMerchantDefinedFieldsFormatGetCollection', options);

/**
 * Get merchant defined fields
 * Retrieves the collection of MerchantDefinedField resources.
 */
export const apiMerchantDefinedFieldsFormatGetCollectionOptions = (options: Options<ApiMerchantDefinedFieldsFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiMerchantDefinedFieldsFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiMerchantDefinedFieldsFormatGetCollectionQueryKey(options)
    });
};

export const apiMerchantDefinedFieldsFormatGetCollectionInfiniteQueryKey = (options: Options<ApiMerchantDefinedFieldsFormatGetCollectionData>): QueryKey<Options<ApiMerchantDefinedFieldsFormatGetCollectionData>> => createQueryKey('apiMerchantDefinedFieldsFormatGetCollection', options, true);

/**
 * Get merchant defined fields
 * Retrieves the collection of MerchantDefinedField resources.
 */
export const apiMerchantDefinedFieldsFormatGetCollectionInfiniteOptions = (options: Options<ApiMerchantDefinedFieldsFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiMerchantDefinedFieldsFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiMerchantDefinedFieldsFormatGetCollectionResponse>, QueryKey<Options<ApiMerchantDefinedFieldsFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiMerchantDefinedFieldsFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiMerchantDefinedFieldsFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiMerchantDefinedFieldsFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiMerchantDefinedFieldsFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiMerchantDefinedFieldsFormatPostQueryKey = (options: Options<ApiMerchantDefinedFieldsFormatPostData>) => createQueryKey('apiMerchantDefinedFieldsFormatPost', options);

/**
 * Create a merchant defined field.
 * # Create a merchant defined field.
 */
export const apiMerchantDefinedFieldsFormatPostOptions = (options: Options<ApiMerchantDefinedFieldsFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiMerchantDefinedFieldsFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiMerchantDefinedFieldsFormatPostQueryKey(options)
    });
};

/**
 * Create a merchant defined field.
 * # Create a merchant defined field.
 */
export const apiMerchantDefinedFieldsFormatPostMutation = (options?: Partial<Options<ApiMerchantDefinedFieldsFormatPostData>>): UseMutationOptions<ApiMerchantDefinedFieldsFormatPostResponse, AxiosError<ApiMerchantDefinedFieldsFormatPostError>, Options<ApiMerchantDefinedFieldsFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiMerchantDefinedFieldsFormatPostResponse, AxiosError<ApiMerchantDefinedFieldsFormatPostError>, Options<ApiMerchantDefinedFieldsFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiMerchantDefinedFieldsFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a merchant defined fields
 * Removes the MerchantDefinedField resource.
 */
export const apiMerchantDefinedFieldsIdFormatDeleteMutation = (options?: Partial<Options<ApiMerchantDefinedFieldsIdFormatDeleteData>>): UseMutationOptions<ApiMerchantDefinedFieldsIdFormatDeleteResponse, AxiosError<ApiMerchantDefinedFieldsIdFormatDeleteError>, Options<ApiMerchantDefinedFieldsIdFormatDeleteData>> => {
    const mutationOptions: UseMutationOptions<ApiMerchantDefinedFieldsIdFormatDeleteResponse, AxiosError<ApiMerchantDefinedFieldsIdFormatDeleteError>, Options<ApiMerchantDefinedFieldsIdFormatDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiMerchantDefinedFieldsIdFormatDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiMerchantDefinedFieldsIdFormatGetQueryKey = (options: Options<ApiMerchantDefinedFieldsIdFormatGetData>) => createQueryKey('apiMerchantDefinedFieldsIdFormatGet', options);

/**
 * Get merchant defined field by ID
 * Retrieves a MerchantDefinedField resource.
 */
export const apiMerchantDefinedFieldsIdFormatGetOptions = (options: Options<ApiMerchantDefinedFieldsIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiMerchantDefinedFieldsIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiMerchantDefinedFieldsIdFormatGetQueryKey(options)
    });
};

/**
 * Update a merchant defined field.
 * # Update a merchant defined field.
 */
export const apiMerchantDefinedFieldsIdFormatPatchMutation = (options?: Partial<Options<ApiMerchantDefinedFieldsIdFormatPatchData>>): UseMutationOptions<ApiMerchantDefinedFieldsIdFormatPatchResponse, AxiosError<ApiMerchantDefinedFieldsIdFormatPatchError>, Options<ApiMerchantDefinedFieldsIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<ApiMerchantDefinedFieldsIdFormatPatchResponse, AxiosError<ApiMerchantDefinedFieldsIdFormatPatchError>, Options<ApiMerchantDefinedFieldsIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiMerchantDefinedFieldsIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiMerchantsFormatGetCollectionQueryKey = (options?: Options<ApiMerchantsFormatGetCollectionData>) => createQueryKey('apiMerchantsFormatGetCollection', options);

/**
 * Retrieves the collection of MerchantSettings resources.
 * Retrieves the collection of MerchantSettings resources.
 */
export const apiMerchantsFormatGetCollectionOptions = (options?: Options<ApiMerchantsFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiMerchantsFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiMerchantsFormatGetCollectionQueryKey(options)
    });
};

export const apiMerchantsFormatGetCollectionInfiniteQueryKey = (options?: Options<ApiMerchantsFormatGetCollectionData>): QueryKey<Options<ApiMerchantsFormatGetCollectionData>> => createQueryKey('apiMerchantsFormatGetCollection', options, true);

/**
 * Retrieves the collection of MerchantSettings resources.
 * Retrieves the collection of MerchantSettings resources.
 */
export const apiMerchantsFormatGetCollectionInfiniteOptions = (options?: Options<ApiMerchantsFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiMerchantsFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiMerchantsFormatGetCollectionResponse>, QueryKey<Options<ApiMerchantsFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiMerchantsFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiMerchantsFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiMerchantsFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiMerchantsFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiMerchantsFormatPostQueryKey = (options: Options<ApiMerchantsFormatPostData>) => createQueryKey('apiMerchantsFormatPost', options);

/**
 * Creates a PostMerchantSettingResource resource.
 * Creates a PostMerchantSettingResource resource.
 */
export const apiMerchantsFormatPostOptions = (options: Options<ApiMerchantsFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiMerchantsFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiMerchantsFormatPostQueryKey(options)
    });
};

/**
 * Creates a PostMerchantSettingResource resource.
 * Creates a PostMerchantSettingResource resource.
 */
export const apiMerchantsFormatPostMutation = (options?: Partial<Options<ApiMerchantsFormatPostData>>): UseMutationOptions<ApiMerchantsFormatPostResponse, AxiosError<ApiMerchantsFormatPostError>, Options<ApiMerchantsFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiMerchantsFormatPostResponse, AxiosError<ApiMerchantsFormatPostError>, Options<ApiMerchantsFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiMerchantsFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Removes the DeleteMerchantSettingResource resource.
 * Removes the DeleteMerchantSettingResource resource.
 */
export const apiMerchantsMerchAccountIdFormatDeleteMutation = (options?: Partial<Options<ApiMerchantsMerchAccountIdFormatDeleteData>>): UseMutationOptions<ApiMerchantsMerchAccountIdFormatDeleteResponse, AxiosError<ApiMerchantsMerchAccountIdFormatDeleteError>, Options<ApiMerchantsMerchAccountIdFormatDeleteData>> => {
    const mutationOptions: UseMutationOptions<ApiMerchantsMerchAccountIdFormatDeleteResponse, AxiosError<ApiMerchantsMerchAccountIdFormatDeleteError>, Options<ApiMerchantsMerchAccountIdFormatDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiMerchantsMerchAccountIdFormatDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiMerchantsMerchAccountIdFormatGetQueryKey = (options: Options<ApiMerchantsMerchAccountIdFormatGetData>) => createQueryKey('apiMerchantsMerchAccountIdFormatGet', options);

/**
 * Retrieves a MerchantSettings resource.
 * Retrieves a MerchantSettings resource.
 */
export const apiMerchantsMerchAccountIdFormatGetOptions = (options: Options<ApiMerchantsMerchAccountIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiMerchantsMerchAccountIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiMerchantsMerchAccountIdFormatGetQueryKey(options)
    });
};

/**
 * Updates the PatchMerchantSettingResource resource.
 * Updates the PatchMerchantSettingResource resource.
 */
export const apiMerchantsMerchAccountIdFormatPatchMutation = (options?: Partial<Options<ApiMerchantsMerchAccountIdFormatPatchData>>): UseMutationOptions<ApiMerchantsMerchAccountIdFormatPatchResponse, AxiosError<ApiMerchantsMerchAccountIdFormatPatchError>, Options<ApiMerchantsMerchAccountIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<ApiMerchantsMerchAccountIdFormatPatchResponse, AxiosError<ApiMerchantsMerchAccountIdFormatPatchError>, Options<ApiMerchantsMerchAccountIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiMerchantsMerchAccountIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiObjectFilesFormatGetCollectionQueryKey = (options: Options<ApiObjectFilesFormatGetCollectionData>) => createQueryKey('apiObjectFilesFormatGetCollection', options);

/**
 * A collection of object files
 * Retrieves the collection of ObjectFile resources.
 */
export const apiObjectFilesFormatGetCollectionOptions = (options: Options<ApiObjectFilesFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiObjectFilesFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiObjectFilesFormatGetCollectionQueryKey(options)
    });
};

export const apiObjectFilesFormatGetCollectionInfiniteQueryKey = (options: Options<ApiObjectFilesFormatGetCollectionData>): QueryKey<Options<ApiObjectFilesFormatGetCollectionData>> => createQueryKey('apiObjectFilesFormatGetCollection', options, true);

/**
 * A collection of object files
 * Retrieves the collection of ObjectFile resources.
 */
export const apiObjectFilesFormatGetCollectionInfiniteOptions = (options: Options<ApiObjectFilesFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiObjectFilesFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiObjectFilesFormatGetCollectionResponse>, QueryKey<Options<ApiObjectFilesFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiObjectFilesFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiObjectFilesFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiObjectFilesFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiObjectFilesFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiObjectFilesFormatPostQueryKey = (options: Options<ApiObjectFilesFormatPostData>) => createQueryKey('apiObjectFilesFormatPost', options);

/**
 * Upload new object file.
 * # Upload new object file.
 */
export const apiObjectFilesFormatPostOptions = (options: Options<ApiObjectFilesFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiObjectFilesFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiObjectFilesFormatPostQueryKey(options)
    });
};

/**
 * Upload new object file.
 * # Upload new object file.
 */
export const apiObjectFilesFormatPostMutation = (options?: Partial<Options<ApiObjectFilesFormatPostData>>): UseMutationOptions<ApiObjectFilesFormatPostResponse, AxiosError<ApiObjectFilesFormatPostError>, Options<ApiObjectFilesFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiObjectFilesFormatPostResponse, AxiosError<ApiObjectFilesFormatPostError>, Options<ApiObjectFilesFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiObjectFilesFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiPaymentsIdFormatGetQueryKey = (options: Options<ApiPaymentsIdFormatGetData>) => createQueryKey('apiPaymentsIdFormatGet', options);

/**
 * Get a single payment by ID.
 * Retrieves a Payment resource.
 */
export const apiPaymentsIdFormatGetOptions = (options: Options<ApiPaymentsIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiPaymentsIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiPaymentsIdFormatGetQueryKey(options)
    });
};

export const apiProductCategoriesFormatGetCollectionQueryKey = (options: Options<ApiProductCategoriesFormatGetCollectionData>) => createQueryKey('apiProductCategoriesFormatGetCollection', options);

/**
 * A collection of product categories
 * Retrieves the collection of Category resources.
 */
export const apiProductCategoriesFormatGetCollectionOptions = (options: Options<ApiProductCategoriesFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductCategoriesFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductCategoriesFormatGetCollectionQueryKey(options)
    });
};

export const apiProductCategoriesFormatGetCollectionInfiniteQueryKey = (options: Options<ApiProductCategoriesFormatGetCollectionData>): QueryKey<Options<ApiProductCategoriesFormatGetCollectionData>> => createQueryKey('apiProductCategoriesFormatGetCollection', options, true);

/**
 * A collection of product categories
 * Retrieves the collection of Category resources.
 */
export const apiProductCategoriesFormatGetCollectionInfiniteOptions = (options: Options<ApiProductCategoriesFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiProductCategoriesFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiProductCategoriesFormatGetCollectionResponse>, QueryKey<Options<ApiProductCategoriesFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiProductCategoriesFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiProductCategoriesFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiProductCategoriesFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductCategoriesFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiProductCategoriesFormatPostQueryKey = (options: Options<ApiProductCategoriesFormatPostData>) => createQueryKey('apiProductCategoriesFormatPost', options);

/**
 * Create new category.
 * # Create new category.
 */
export const apiProductCategoriesFormatPostOptions = (options: Options<ApiProductCategoriesFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductCategoriesFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductCategoriesFormatPostQueryKey(options)
    });
};

/**
 * Create new category.
 * # Create new category.
 */
export const apiProductCategoriesFormatPostMutation = (options?: Partial<Options<ApiProductCategoriesFormatPostData>>): UseMutationOptions<ApiProductCategoriesFormatPostResponse, AxiosError<ApiProductCategoriesFormatPostError>, Options<ApiProductCategoriesFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiProductCategoriesFormatPostResponse, AxiosError<ApiProductCategoriesFormatPostError>, Options<ApiProductCategoriesFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductCategoriesFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a category.
 * # Delete a category.
 */
export const apiProductCategoriesIdFormatDeleteMutation = (options?: Partial<Options<ApiProductCategoriesIdFormatDeleteData>>): UseMutationOptions<ApiProductCategoriesIdFormatDeleteResponse, AxiosError<ApiProductCategoriesIdFormatDeleteError>, Options<ApiProductCategoriesIdFormatDeleteData>> => {
    const mutationOptions: UseMutationOptions<ApiProductCategoriesIdFormatDeleteResponse, AxiosError<ApiProductCategoriesIdFormatDeleteError>, Options<ApiProductCategoriesIdFormatDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductCategoriesIdFormatDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiProductCategoriesIdFormatGetQueryKey = (options: Options<ApiProductCategoriesIdFormatGetData>) => createQueryKey('apiProductCategoriesIdFormatGet', options);

/**
 * Get a single category.
 * Retrieves a Category resource.
 */
export const apiProductCategoriesIdFormatGetOptions = (options: Options<ApiProductCategoriesIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductCategoriesIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductCategoriesIdFormatGetQueryKey(options)
    });
};

/**
 * Update a category.
 * # Update a category.
 */
export const apiProductCategoriesIdFormatPatchMutation = (options?: Partial<Options<ApiProductCategoriesIdFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiProductCategoriesIdFormatPatchError>, Options<ApiProductCategoriesIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiProductCategoriesIdFormatPatchError>, Options<ApiProductCategoriesIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductCategoriesIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiProductDetailByLocationFormatGetCollectionQueryKey = (options: Options<ApiProductDetailByLocationFormatGetCollectionData>) => createQueryKey('apiProductDetailByLocationFormatGetCollection', options);

/**
 * A collection of product details by location
 * Retrieves the collection of ProductDetailByLocation resources.
 */
export const apiProductDetailByLocationFormatGetCollectionOptions = (options: Options<ApiProductDetailByLocationFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductDetailByLocationFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductDetailByLocationFormatGetCollectionQueryKey(options)
    });
};

export const apiProductDetailByLocationFormatGetCollectionInfiniteQueryKey = (options: Options<ApiProductDetailByLocationFormatGetCollectionData>): QueryKey<Options<ApiProductDetailByLocationFormatGetCollectionData>> => createQueryKey('apiProductDetailByLocationFormatGetCollection', options, true);

/**
 * A collection of product details by location
 * Retrieves the collection of ProductDetailByLocation resources.
 */
export const apiProductDetailByLocationFormatGetCollectionInfiniteOptions = (options: Options<ApiProductDetailByLocationFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiProductDetailByLocationFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiProductDetailByLocationFormatGetCollectionResponse>, QueryKey<Options<ApiProductDetailByLocationFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiProductDetailByLocationFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiProductDetailByLocationFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiProductDetailByLocationFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductDetailByLocationFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiProductDetailByLocationFormatPostQueryKey = (options: Options<ApiProductDetailByLocationFormatPostData>) => createQueryKey('apiProductDetailByLocationFormatPost', options);

/**
 * Create new product detail by location.
 * # Create new product detail by location.
 */
export const apiProductDetailByLocationFormatPostOptions = (options: Options<ApiProductDetailByLocationFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductDetailByLocationFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductDetailByLocationFormatPostQueryKey(options)
    });
};

/**
 * Create new product detail by location.
 * # Create new product detail by location.
 */
export const apiProductDetailByLocationFormatPostMutation = (options?: Partial<Options<ApiProductDetailByLocationFormatPostData>>): UseMutationOptions<ApiProductDetailByLocationFormatPostResponse, AxiosError<ApiProductDetailByLocationFormatPostError>, Options<ApiProductDetailByLocationFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiProductDetailByLocationFormatPostResponse, AxiosError<ApiProductDetailByLocationFormatPostError>, Options<ApiProductDetailByLocationFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductDetailByLocationFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a product detail by location.
 * # Delete a product detail by location.
 */
export const apiProductDetailByLocationIdFormatDeleteMutation = (options?: Partial<Options<ApiProductDetailByLocationIdFormatDeleteData>>): UseMutationOptions<ApiProductDetailByLocationIdFormatDeleteResponse, AxiosError<ApiProductDetailByLocationIdFormatDeleteError>, Options<ApiProductDetailByLocationIdFormatDeleteData>> => {
    const mutationOptions: UseMutationOptions<ApiProductDetailByLocationIdFormatDeleteResponse, AxiosError<ApiProductDetailByLocationIdFormatDeleteError>, Options<ApiProductDetailByLocationIdFormatDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductDetailByLocationIdFormatDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiProductDetailByLocationIdFormatGetQueryKey = (options: Options<ApiProductDetailByLocationIdFormatGetData>) => createQueryKey('apiProductDetailByLocationIdFormatGet', options);

/**
 * Get a single product detail by location.
 * Retrieves a ProductDetailByLocation resource.
 */
export const apiProductDetailByLocationIdFormatGetOptions = (options: Options<ApiProductDetailByLocationIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductDetailByLocationIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductDetailByLocationIdFormatGetQueryKey(options)
    });
};

/**
 * Update a product detail by location.
 * # Update a product detail by location.
 */
export const apiProductDetailByLocationIdFormatPatchMutation = (options?: Partial<Options<ApiProductDetailByLocationIdFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiProductDetailByLocationIdFormatPatchError>, Options<ApiProductDetailByLocationIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiProductDetailByLocationIdFormatPatchError>, Options<ApiProductDetailByLocationIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductDetailByLocationIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiProductLocationsFormatGetCollectionQueryKey = (options: Options<ApiProductLocationsFormatGetCollectionData>) => createQueryKey('apiProductLocationsFormatGetCollection', options);

/**
 * A collection of product locations
 * Retrieves the collection of Location resources.
 */
export const apiProductLocationsFormatGetCollectionOptions = (options: Options<ApiProductLocationsFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductLocationsFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductLocationsFormatGetCollectionQueryKey(options)
    });
};

export const apiProductLocationsFormatGetCollectionInfiniteQueryKey = (options: Options<ApiProductLocationsFormatGetCollectionData>): QueryKey<Options<ApiProductLocationsFormatGetCollectionData>> => createQueryKey('apiProductLocationsFormatGetCollection', options, true);

/**
 * A collection of product locations
 * Retrieves the collection of Location resources.
 */
export const apiProductLocationsFormatGetCollectionInfiniteOptions = (options: Options<ApiProductLocationsFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiProductLocationsFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiProductLocationsFormatGetCollectionResponse>, QueryKey<Options<ApiProductLocationsFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiProductLocationsFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiProductLocationsFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiProductLocationsFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductLocationsFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiProductLocationsFormatPostQueryKey = (options: Options<ApiProductLocationsFormatPostData>) => createQueryKey('apiProductLocationsFormatPost', options);

/**
 * Create new location.
 * # Create new location.
 */
export const apiProductLocationsFormatPostOptions = (options: Options<ApiProductLocationsFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductLocationsFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductLocationsFormatPostQueryKey(options)
    });
};

/**
 * Create new location.
 * # Create new location.
 */
export const apiProductLocationsFormatPostMutation = (options?: Partial<Options<ApiProductLocationsFormatPostData>>): UseMutationOptions<ApiProductLocationsFormatPostResponse, AxiosError<ApiProductLocationsFormatPostError>, Options<ApiProductLocationsFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiProductLocationsFormatPostResponse, AxiosError<ApiProductLocationsFormatPostError>, Options<ApiProductLocationsFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductLocationsFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a location.
 * # Delete a location.
 */
export const apiProductLocationsIdFormatDeleteMutation = (options?: Partial<Options<ApiProductLocationsIdFormatDeleteData>>): UseMutationOptions<ApiProductLocationsIdFormatDeleteResponse, AxiosError<ApiProductLocationsIdFormatDeleteError>, Options<ApiProductLocationsIdFormatDeleteData>> => {
    const mutationOptions: UseMutationOptions<ApiProductLocationsIdFormatDeleteResponse, AxiosError<ApiProductLocationsIdFormatDeleteError>, Options<ApiProductLocationsIdFormatDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductLocationsIdFormatDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiProductLocationsIdFormatGetQueryKey = (options: Options<ApiProductLocationsIdFormatGetData>) => createQueryKey('apiProductLocationsIdFormatGet', options);

/**
 * Get a single location.
 * Retrieves a Location resource.
 */
export const apiProductLocationsIdFormatGetOptions = (options: Options<ApiProductLocationsIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductLocationsIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductLocationsIdFormatGetQueryKey(options)
    });
};

/**
 * Update a location.
 * # Update a location.
 */
export const apiProductLocationsIdFormatPatchMutation = (options?: Partial<Options<ApiProductLocationsIdFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiProductLocationsIdFormatPatchError>, Options<ApiProductLocationsIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiProductLocationsIdFormatPatchError>, Options<ApiProductLocationsIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductLocationsIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiProductPackageProductDetailByLocationPackageIdFormatGetCollectionQueryKey = (options: Options<ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionData>) => createQueryKey('apiProductPackageProductDetailByLocationPackageIdFormatGetCollection', options);

/**
 * Get list product detail by location by package.
 * Retrieves the collection of PackageProductDetailByLocation resources.
 */
export const apiProductPackageProductDetailByLocationPackageIdFormatGetCollectionOptions = (options: Options<ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductPackageProductDetailByLocationPackageIdFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductPackageProductDetailByLocationPackageIdFormatGetCollectionQueryKey(options)
    });
};

export const apiProductPackageProductDetailByLocationPackageIdFormatGetCollectionInfiniteQueryKey = (options: Options<ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionData>): QueryKey<Options<ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionData>> => createQueryKey('apiProductPackageProductDetailByLocationPackageIdFormatGetCollection', options, true);

/**
 * Get list product detail by location by package.
 * Retrieves the collection of PackageProductDetailByLocation resources.
 */
export const apiProductPackageProductDetailByLocationPackageIdFormatGetCollectionInfiniteOptions = (options: Options<ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionResponse>, QueryKey<Options<ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiProductPackageProductDetailByLocationPackageIdFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiProductPackageProductDetailByLocationPackageIdFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductPackageProductDetailByLocationPackageIdFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiProductPackagesFormatGetCollectionQueryKey = (options: Options<ApiProductPackagesFormatGetCollectionData>) => createQueryKey('apiProductPackagesFormatGetCollection', options);

/**
 * A collection of product packages
 * Retrieves the collection of Package resources.
 */
export const apiProductPackagesFormatGetCollectionOptions = (options: Options<ApiProductPackagesFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductPackagesFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductPackagesFormatGetCollectionQueryKey(options)
    });
};

export const apiProductPackagesFormatGetCollectionInfiniteQueryKey = (options: Options<ApiProductPackagesFormatGetCollectionData>): QueryKey<Options<ApiProductPackagesFormatGetCollectionData>> => createQueryKey('apiProductPackagesFormatGetCollection', options, true);

/**
 * A collection of product packages
 * Retrieves the collection of Package resources.
 */
export const apiProductPackagesFormatGetCollectionInfiniteOptions = (options: Options<ApiProductPackagesFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiProductPackagesFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiProductPackagesFormatGetCollectionResponse>, QueryKey<Options<ApiProductPackagesFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiProductPackagesFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiProductPackagesFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiProductPackagesFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductPackagesFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiProductPackagesFormatPostQueryKey = (options: Options<ApiProductPackagesFormatPostData>) => createQueryKey('apiProductPackagesFormatPost', options);

/**
 * Create new package.
 * # Create new package.
 */
export const apiProductPackagesFormatPostOptions = (options: Options<ApiProductPackagesFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductPackagesFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductPackagesFormatPostQueryKey(options)
    });
};

/**
 * Create new package.
 * # Create new package.
 */
export const apiProductPackagesFormatPostMutation = (options?: Partial<Options<ApiProductPackagesFormatPostData>>): UseMutationOptions<unknown, AxiosError<ApiProductPackagesFormatPostError>, Options<ApiProductPackagesFormatPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiProductPackagesFormatPostError>, Options<ApiProductPackagesFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductPackagesFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a package.
 * # Delete a package.
 */
export const apiProductPackagesIdFormatDeleteMutation = (options?: Partial<Options<ApiProductPackagesIdFormatDeleteData>>): UseMutationOptions<ApiProductPackagesIdFormatDeleteResponse, AxiosError<ApiProductPackagesIdFormatDeleteError>, Options<ApiProductPackagesIdFormatDeleteData>> => {
    const mutationOptions: UseMutationOptions<ApiProductPackagesIdFormatDeleteResponse, AxiosError<ApiProductPackagesIdFormatDeleteError>, Options<ApiProductPackagesIdFormatDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductPackagesIdFormatDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiProductPackagesIdFormatGetQueryKey = (options: Options<ApiProductPackagesIdFormatGetData>) => createQueryKey('apiProductPackagesIdFormatGet', options);

/**
 * Get a single package.
 * Retrieves a Package resource.
 */
export const apiProductPackagesIdFormatGetOptions = (options: Options<ApiProductPackagesIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductPackagesIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductPackagesIdFormatGetQueryKey(options)
    });
};

/**
 * Update a package.
 * # Update a package.
 */
export const apiProductPackagesIdFormatPatchMutation = (options?: Partial<Options<ApiProductPackagesIdFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiProductPackagesIdFormatPatchError>, Options<ApiProductPackagesIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiProductPackagesIdFormatPatchError>, Options<ApiProductPackagesIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductPackagesIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiProductStockOrderItemsStockOrderIdFormatGetCollectionQueryKey = (options: Options<ApiProductStockOrderItemsStockOrderIdFormatGetCollectionData>) => createQueryKey('apiProductStockOrderItemsStockOrderIdFormatGetCollection', options);

/**
 * Get list stock order item of stock order.
 * Retrieves the collection of StockOrderItem resources.
 */
export const apiProductStockOrderItemsStockOrderIdFormatGetCollectionOptions = (options: Options<ApiProductStockOrderItemsStockOrderIdFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductStockOrderItemsStockOrderIdFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductStockOrderItemsStockOrderIdFormatGetCollectionQueryKey(options)
    });
};

export const apiProductStockOrderItemsStockOrderIdFormatGetCollectionInfiniteQueryKey = (options: Options<ApiProductStockOrderItemsStockOrderIdFormatGetCollectionData>): QueryKey<Options<ApiProductStockOrderItemsStockOrderIdFormatGetCollectionData>> => createQueryKey('apiProductStockOrderItemsStockOrderIdFormatGetCollection', options, true);

/**
 * Get list stock order item of stock order.
 * Retrieves the collection of StockOrderItem resources.
 */
export const apiProductStockOrderItemsStockOrderIdFormatGetCollectionInfiniteOptions = (options: Options<ApiProductStockOrderItemsStockOrderIdFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiProductStockOrderItemsStockOrderIdFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiProductStockOrderItemsStockOrderIdFormatGetCollectionResponse>, QueryKey<Options<ApiProductStockOrderItemsStockOrderIdFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiProductStockOrderItemsStockOrderIdFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiProductStockOrderItemsStockOrderIdFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiProductStockOrderItemsStockOrderIdFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductStockOrderItemsStockOrderIdFormatGetCollectionInfiniteQueryKey(options)
    });
};

/**
 * Update a stock order status.
 * # Update a stock order status.
 */
export const apiProductStockOrderStatusIdFormatPatchMutation = (options?: Partial<Options<ApiProductStockOrderStatusIdFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiProductStockOrderStatusIdFormatPatchError>, Options<ApiProductStockOrderStatusIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiProductStockOrderStatusIdFormatPatchError>, Options<ApiProductStockOrderStatusIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductStockOrderStatusIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiProductStockOrdersFormatGetCollectionQueryKey = (options: Options<ApiProductStockOrdersFormatGetCollectionData>) => createQueryKey('apiProductStockOrdersFormatGetCollection', options);

/**
 * A collection of stock orders
 * Retrieves the collection of StockOrder resources.
 */
export const apiProductStockOrdersFormatGetCollectionOptions = (options: Options<ApiProductStockOrdersFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductStockOrdersFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductStockOrdersFormatGetCollectionQueryKey(options)
    });
};

export const apiProductStockOrdersFormatGetCollectionInfiniteQueryKey = (options: Options<ApiProductStockOrdersFormatGetCollectionData>): QueryKey<Options<ApiProductStockOrdersFormatGetCollectionData>> => createQueryKey('apiProductStockOrdersFormatGetCollection', options, true);

/**
 * A collection of stock orders
 * Retrieves the collection of StockOrder resources.
 */
export const apiProductStockOrdersFormatGetCollectionInfiniteOptions = (options: Options<ApiProductStockOrdersFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiProductStockOrdersFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiProductStockOrdersFormatGetCollectionResponse>, QueryKey<Options<ApiProductStockOrdersFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiProductStockOrdersFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiProductStockOrdersFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiProductStockOrdersFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductStockOrdersFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiProductStockOrdersFormatPostQueryKey = (options: Options<ApiProductStockOrdersFormatPostData>) => createQueryKey('apiProductStockOrdersFormatPost', options);

/**
 * Create new stock order.
 * # Create new stock order.
 */
export const apiProductStockOrdersFormatPostOptions = (options: Options<ApiProductStockOrdersFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductStockOrdersFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductStockOrdersFormatPostQueryKey(options)
    });
};

/**
 * Create new stock order.
 * # Create new stock order.
 */
export const apiProductStockOrdersFormatPostMutation = (options?: Partial<Options<ApiProductStockOrdersFormatPostData>>): UseMutationOptions<ApiProductStockOrdersFormatPostResponse, AxiosError<ApiProductStockOrdersFormatPostError>, Options<ApiProductStockOrdersFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiProductStockOrdersFormatPostResponse, AxiosError<ApiProductStockOrdersFormatPostError>, Options<ApiProductStockOrdersFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductStockOrdersFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a stock order.
 * # Delete a stock order.
 */
export const apiProductStockOrdersIdFormatDeleteMutation = (options?: Partial<Options<ApiProductStockOrdersIdFormatDeleteData>>): UseMutationOptions<ApiProductStockOrdersIdFormatDeleteResponse, AxiosError<ApiProductStockOrdersIdFormatDeleteError>, Options<ApiProductStockOrdersIdFormatDeleteData>> => {
    const mutationOptions: UseMutationOptions<ApiProductStockOrdersIdFormatDeleteResponse, AxiosError<ApiProductStockOrdersIdFormatDeleteError>, Options<ApiProductStockOrdersIdFormatDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductStockOrdersIdFormatDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiProductStockOrdersIdFormatGetQueryKey = (options: Options<ApiProductStockOrdersIdFormatGetData>) => createQueryKey('apiProductStockOrdersIdFormatGet', options);

/**
 * Get a single stock order.
 * Retrieves a StockOrder resource.
 */
export const apiProductStockOrdersIdFormatGetOptions = (options: Options<ApiProductStockOrdersIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductStockOrdersIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductStockOrdersIdFormatGetQueryKey(options)
    });
};

/**
 * Update a stock order.
 * # Update a stock order.
 */
export const apiProductStockOrdersIdFormatPatchMutation = (options?: Partial<Options<ApiProductStockOrdersIdFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiProductStockOrdersIdFormatPatchError>, Options<ApiProductStockOrdersIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiProductStockOrdersIdFormatPatchError>, Options<ApiProductStockOrdersIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductStockOrdersIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiProductsFormatGetCollectionQueryKey = (options: Options<ApiProductsFormatGetCollectionData>) => createQueryKey('apiProductsFormatGetCollection', options);

/**
 * A collection of products
 * Retrieves the collection of Product resources.
 */
export const apiProductsFormatGetCollectionOptions = (options: Options<ApiProductsFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductsFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductsFormatGetCollectionQueryKey(options)
    });
};

export const apiProductsFormatGetCollectionInfiniteQueryKey = (options: Options<ApiProductsFormatGetCollectionData>): QueryKey<Options<ApiProductsFormatGetCollectionData>> => createQueryKey('apiProductsFormatGetCollection', options, true);

/**
 * A collection of products
 * Retrieves the collection of Product resources.
 */
export const apiProductsFormatGetCollectionInfiniteOptions = (options: Options<ApiProductsFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiProductsFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiProductsFormatGetCollectionResponse>, QueryKey<Options<ApiProductsFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiProductsFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiProductsFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiProductsFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductsFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiProductsFormatPostQueryKey = (options: Options<ApiProductsFormatPostData>) => createQueryKey('apiProductsFormatPost', options);

/**
 * Create new product.
 * # Create new product.
 */
export const apiProductsFormatPostOptions = (options: Options<ApiProductsFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductsFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductsFormatPostQueryKey(options)
    });
};

/**
 * Create new product.
 * # Create new product.
 */
export const apiProductsFormatPostMutation = (options?: Partial<Options<ApiProductsFormatPostData>>): UseMutationOptions<ApiProductsFormatPostResponse, AxiosError<ApiProductsFormatPostError>, Options<ApiProductsFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiProductsFormatPostResponse, AxiosError<ApiProductsFormatPostError>, Options<ApiProductsFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductsFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a product.
 * # Delete a product.
 */
export const apiProductsIdFormatDeleteMutation = (options?: Partial<Options<ApiProductsIdFormatDeleteData>>): UseMutationOptions<ApiProductsIdFormatDeleteResponse, AxiosError<ApiProductsIdFormatDeleteError>, Options<ApiProductsIdFormatDeleteData>> => {
    const mutationOptions: UseMutationOptions<ApiProductsIdFormatDeleteResponse, AxiosError<ApiProductsIdFormatDeleteError>, Options<ApiProductsIdFormatDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductsIdFormatDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiProductsIdFormatGetQueryKey = (options: Options<ApiProductsIdFormatGetData>) => createQueryKey('apiProductsIdFormatGet', options);

/**
 * Get a single product.
 * Retrieves a Product resource.
 */
export const apiProductsIdFormatGetOptions = (options: Options<ApiProductsIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiProductsIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiProductsIdFormatGetQueryKey(options)
    });
};

/**
 * Update a product.
 * # Update a product.
 */
export const apiProductsIdFormatPatchMutation = (options?: Partial<Options<ApiProductsIdFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiProductsIdFormatPatchError>, Options<ApiProductsIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiProductsIdFormatPatchError>, Options<ApiProductsIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiProductsIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiPlansFormatGetCollectionQueryKey = (options: Options<ApiPlansFormatGetCollectionData>) => createQueryKey('apiPlansFormatGetCollection', options);

/**
 * A collection of plans
 * Retrieves the collection of Plan resources.
 */
export const apiPlansFormatGetCollectionOptions = (options: Options<ApiPlansFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiPlansFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiPlansFormatGetCollectionQueryKey(options)
    });
};

export const apiPlansFormatGetCollectionInfiniteQueryKey = (options: Options<ApiPlansFormatGetCollectionData>): QueryKey<Options<ApiPlansFormatGetCollectionData>> => createQueryKey('apiPlansFormatGetCollection', options, true);

/**
 * A collection of plans
 * Retrieves the collection of Plan resources.
 */
export const apiPlansFormatGetCollectionInfiniteOptions = (options: Options<ApiPlansFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiPlansFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiPlansFormatGetCollectionResponse>, QueryKey<Options<ApiPlansFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiPlansFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiPlansFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiPlansFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiPlansFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiPlansFormatPostQueryKey = (options: Options<ApiPlansFormatPostData>) => createQueryKey('apiPlansFormatPost', options);

/**
 * Create new plan
 * # Create new plan
 */
export const apiPlansFormatPostOptions = (options: Options<ApiPlansFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiPlansFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiPlansFormatPostQueryKey(options)
    });
};

/**
 * Create new plan
 * # Create new plan
 */
export const apiPlansFormatPostMutation = (options?: Partial<Options<ApiPlansFormatPostData>>): UseMutationOptions<ApiPlansFormatPostResponse, AxiosError<ApiPlansFormatPostError>, Options<ApiPlansFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiPlansFormatPostResponse, AxiosError<ApiPlansFormatPostError>, Options<ApiPlansFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiPlansFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a plan
 * Removes the Plan resource.
 */
export const apiPlansIdFormatDeleteMutation = (options?: Partial<Options<ApiPlansIdFormatDeleteData>>): UseMutationOptions<ApiPlansIdFormatDeleteResponse, AxiosError<ApiPlansIdFormatDeleteError>, Options<ApiPlansIdFormatDeleteData>> => {
    const mutationOptions: UseMutationOptions<ApiPlansIdFormatDeleteResponse, AxiosError<ApiPlansIdFormatDeleteError>, Options<ApiPlansIdFormatDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiPlansIdFormatDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiPlansIdFormatGetQueryKey = (options: Options<ApiPlansIdFormatGetData>) => createQueryKey('apiPlansIdFormatGet', options);

/**
 * Get a single plan
 * Retrieves a Plan resource.
 */
export const apiPlansIdFormatGetOptions = (options: Options<ApiPlansIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiPlansIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiPlansIdFormatGetQueryKey(options)
    });
};

/**
 * Update a plan
 * Updates the PatchPlanResource resource.
 */
export const apiPlansIdFormatPatchMutation = (options?: Partial<Options<ApiPlansIdFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiPlansIdFormatPatchError>, Options<ApiPlansIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiPlansIdFormatPatchError>, Options<ApiPlansIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiPlansIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update status a recur
 * Updates the PatchRecurStatusResource resource.
 */
export const apiRecurStatusRecurIdFormatPatchMutation = (options?: Partial<Options<ApiRecurStatusRecurIdFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiRecurStatusRecurIdFormatPatchError>, Options<ApiRecurStatusRecurIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiRecurStatusRecurIdFormatPatchError>, Options<ApiRecurStatusRecurIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiRecurStatusRecurIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiRecursFormatGetCollectionQueryKey = (options: Options<ApiRecursFormatGetCollectionData>) => createQueryKey('apiRecursFormatGetCollection', options);

/**
 * A collection of recurs
 * Retrieves the collection of Recur resources.
 */
export const apiRecursFormatGetCollectionOptions = (options: Options<ApiRecursFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiRecursFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiRecursFormatGetCollectionQueryKey(options)
    });
};

export const apiRecursFormatGetCollectionInfiniteQueryKey = (options: Options<ApiRecursFormatGetCollectionData>): QueryKey<Options<ApiRecursFormatGetCollectionData>> => createQueryKey('apiRecursFormatGetCollection', options, true);

/**
 * A collection of recurs
 * Retrieves the collection of Recur resources.
 */
export const apiRecursFormatGetCollectionInfiniteOptions = (options: Options<ApiRecursFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiRecursFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiRecursFormatGetCollectionResponse>, QueryKey<Options<ApiRecursFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiRecursFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiRecursFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiRecursFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiRecursFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiRecursFormatPostQueryKey = (options: Options<ApiRecursFormatPostData>) => createQueryKey('apiRecursFormatPost', options);

/**
 * Create new recur
 * # Create new recur
 */
export const apiRecursFormatPostOptions = (options: Options<ApiRecursFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiRecursFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiRecursFormatPostQueryKey(options)
    });
};

/**
 * Create new recur
 * # Create new recur
 */
export const apiRecursFormatPostMutation = (options?: Partial<Options<ApiRecursFormatPostData>>): UseMutationOptions<ApiRecursFormatPostResponse, AxiosError<ApiRecursFormatPostError>, Options<ApiRecursFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiRecursFormatPostResponse, AxiosError<ApiRecursFormatPostError>, Options<ApiRecursFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiRecursFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a recur
 * Removes the Recur resource.
 */
export const apiRecursIdFormatDeleteMutation = (options?: Partial<Options<ApiRecursIdFormatDeleteData>>): UseMutationOptions<ApiRecursIdFormatDeleteResponse, AxiosError<ApiRecursIdFormatDeleteError>, Options<ApiRecursIdFormatDeleteData>> => {
    const mutationOptions: UseMutationOptions<ApiRecursIdFormatDeleteResponse, AxiosError<ApiRecursIdFormatDeleteError>, Options<ApiRecursIdFormatDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiRecursIdFormatDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiRecursIdFormatGetQueryKey = (options: Options<ApiRecursIdFormatGetData>) => createQueryKey('apiRecursIdFormatGet', options);

/**
 * Get a single recur.
 * Retrieves a Recur resource.
 */
export const apiRecursIdFormatGetOptions = (options: Options<ApiRecursIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiRecursIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiRecursIdFormatGetQueryKey(options)
    });
};

/**
 * Update a recur
 * Updates the PatchRecurResource resource.
 */
export const apiRecursIdFormatPatchMutation = (options?: Partial<Options<ApiRecursIdFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiRecursIdFormatPatchError>, Options<ApiRecursIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiRecursIdFormatPatchError>, Options<ApiRecursIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiRecursIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiTransactionSignatureIdFormatGetQueryKey = (options: Options<ApiTransactionSignatureIdFormatGetData>) => createQueryKey('apiTransactionSignatureIdFormatGet', options);

/**
 * Retrieves a Signature resource.
 * Retrieves a Signature resource.
 */
export const apiTransactionSignatureIdFormatGetOptions = (options: Options<ApiTransactionSignatureIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionSignatureIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionSignatureIdFormatGetQueryKey(options)
    });
};

export const apiBatchesreopenBatchIdFormatPostQueryKey = (options: Options<ApiBatchesreopenBatchIdFormatPostData>) => createQueryKey('apiBatchesreopenBatchIdFormatPost', options);

/**
 * Manage batch request by batch id.
 * Creates a PostReopenBatchResource resource.
 */
export const apiBatchesreopenBatchIdFormatPostOptions = (options: Options<ApiBatchesreopenBatchIdFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiBatchesreopenBatchIdFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiBatchesreopenBatchIdFormatPostQueryKey(options)
    });
};

/**
 * Manage batch request by batch id.
 * Creates a PostReopenBatchResource resource.
 */
export const apiBatchesreopenBatchIdFormatPostMutation = (options?: Partial<Options<ApiBatchesreopenBatchIdFormatPostData>>): UseMutationOptions<unknown, AxiosError<ApiBatchesreopenBatchIdFormatPostError>, Options<ApiBatchesreopenBatchIdFormatPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiBatchesreopenBatchIdFormatPostError>, Options<ApiBatchesreopenBatchIdFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiBatchesreopenBatchIdFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiManagebdkFormatGetCollectionQueryKey = (options?: Options<ApiManagebdkFormatGetCollectionData>) => createQueryKey('apiManagebdkFormatGetCollection', options);

/**
 * Retrieves the collection of BDK resources.
 * Retrieves the collection of BDK resources.
 */
export const apiManagebdkFormatGetCollectionOptions = (options?: Options<ApiManagebdkFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiManagebdkFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiManagebdkFormatGetCollectionQueryKey(options)
    });
};

export const apiManagebdkFormatGetCollectionInfiniteQueryKey = (options?: Options<ApiManagebdkFormatGetCollectionData>): QueryKey<Options<ApiManagebdkFormatGetCollectionData>> => createQueryKey('apiManagebdkFormatGetCollection', options, true);

/**
 * Retrieves the collection of BDK resources.
 * Retrieves the collection of BDK resources.
 */
export const apiManagebdkFormatGetCollectionInfiniteOptions = (options?: Options<ApiManagebdkFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiManagebdkFormatGetCollectionResponse, AxiosError<ApiManagebdkFormatGetCollectionError>, InfiniteData<ApiManagebdkFormatGetCollectionResponse>, QueryKey<Options<ApiManagebdkFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiManagebdkFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiManagebdkFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiManagebdkFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiManagebdkFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiManagebdkFormatPostQueryKey = (options: Options<ApiManagebdkFormatPostData>) => createQueryKey('apiManagebdkFormatPost', options);

/**
 * Creates a PostBDKResource resource.
 * Creates a PostBDKResource resource.
 */
export const apiManagebdkFormatPostOptions = (options: Options<ApiManagebdkFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiManagebdkFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiManagebdkFormatPostQueryKey(options)
    });
};

/**
 * Creates a PostBDKResource resource.
 * Creates a PostBDKResource resource.
 */
export const apiManagebdkFormatPostMutation = (options?: Partial<Options<ApiManagebdkFormatPostData>>): UseMutationOptions<unknown, AxiosError<ApiManagebdkFormatPostError>, Options<ApiManagebdkFormatPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiManagebdkFormatPostError>, Options<ApiManagebdkFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiManagebdkFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Removes the BDK resource.
 * Removes the BDK resource.
 */
export const apiManagebdkIdFormatDeleteMutation = (options?: Partial<Options<ApiManagebdkIdFormatDeleteData>>): UseMutationOptions<ApiManagebdkIdFormatDeleteResponse, AxiosError<ApiManagebdkIdFormatDeleteError>, Options<ApiManagebdkIdFormatDeleteData>> => {
    const mutationOptions: UseMutationOptions<ApiManagebdkIdFormatDeleteResponse, AxiosError<ApiManagebdkIdFormatDeleteError>, Options<ApiManagebdkIdFormatDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiManagebdkIdFormatDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiManagebdkIdFormatGetQueryKey = (options: Options<ApiManagebdkIdFormatGetData>) => createQueryKey('apiManagebdkIdFormatGet', options);

/**
 * Retrieves a BDK resource.
 * Retrieves a BDK resource.
 */
export const apiManagebdkIdFormatGetOptions = (options: Options<ApiManagebdkIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiManagebdkIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiManagebdkIdFormatGetQueryKey(options)
    });
};

/**
 * Updates the PatchBDKResource resource.
 * Updates the PatchBDKResource resource.
 */
export const apiManagebdkIdFormatPatchMutation = (options?: Partial<Options<ApiManagebdkIdFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiManagebdkIdFormatPatchError>, Options<ApiManagebdkIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiManagebdkIdFormatPatchError>, Options<ApiManagebdkIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiManagebdkIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiTransactionsallFormatGetCollectionQueryKey = (options: Options<ApiTransactionsallFormatGetCollectionData>) => createQueryKey('apiTransactionsallFormatGetCollection', options);

/**
 * Retrieves the collection of AllTransaction resources.
 * Retrieves the collection of AllTransaction resources.
 */
export const apiTransactionsallFormatGetCollectionOptions = (options: Options<ApiTransactionsallFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsallFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsallFormatGetCollectionQueryKey(options)
    });
};

export const apiTransactionsallFormatGetCollectionInfiniteQueryKey = (options: Options<ApiTransactionsallFormatGetCollectionData>): QueryKey<Options<ApiTransactionsallFormatGetCollectionData>> => createQueryKey('apiTransactionsallFormatGetCollection', options, true);

/**
 * Retrieves the collection of AllTransaction resources.
 * Retrieves the collection of AllTransaction resources.
 */
export const apiTransactionsallFormatGetCollectionInfiniteOptions = (options: Options<ApiTransactionsallFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiTransactionsallFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiTransactionsallFormatGetCollectionResponse>, QueryKey<Options<ApiTransactionsallFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiTransactionsallFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiTransactionsallFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiTransactionsallFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsallFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiTransactionsauthToSaleFormatPostQueryKey = (options: Options<ApiTransactionsauthToSaleFormatPostData>) => createQueryKey('apiTransactionsauthToSaleFormatPost', options);

/**
 * Creates a AuthToSaleResource resource.
 * Creates a AuthToSaleResource resource.
 */
export const apiTransactionsauthToSaleFormatPostOptions = (options: Options<ApiTransactionsauthToSaleFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsauthToSaleFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsauthToSaleFormatPostQueryKey(options)
    });
};

/**
 * Creates a AuthToSaleResource resource.
 * Creates a AuthToSaleResource resource.
 */
export const apiTransactionsauthToSaleFormatPostMutation = (options?: Partial<Options<ApiTransactionsauthToSaleFormatPostData>>): UseMutationOptions<ApiTransactionsauthToSaleFormatPostResponse, AxiosError<ApiTransactionsauthToSaleFormatPostError>, Options<ApiTransactionsauthToSaleFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiTransactionsauthToSaleFormatPostResponse, AxiosError<ApiTransactionsauthToSaleFormatPostError>, Options<ApiTransactionsauthToSaleFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiTransactionsauthToSaleFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiTransactionsbatchCloseFormatPostQueryKey = (options: Options<ApiTransactionsbatchCloseFormatPostData>) => createQueryKey('apiTransactionsbatchCloseFormatPost', options);

/**
 * Creates a BatchCloseResource resource.
 * Creates a BatchCloseResource resource.
 */
export const apiTransactionsbatchCloseFormatPostOptions = (options: Options<ApiTransactionsbatchCloseFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsbatchCloseFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsbatchCloseFormatPostQueryKey(options)
    });
};

/**
 * Creates a BatchCloseResource resource.
 * Creates a BatchCloseResource resource.
 */
export const apiTransactionsbatchCloseFormatPostMutation = (options?: Partial<Options<ApiTransactionsbatchCloseFormatPostData>>): UseMutationOptions<ApiTransactionsbatchCloseFormatPostResponse, AxiosError<ApiTransactionsbatchCloseFormatPostError>, Options<ApiTransactionsbatchCloseFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiTransactionsbatchCloseFormatPostResponse, AxiosError<ApiTransactionsbatchCloseFormatPostError>, Options<ApiTransactionsbatchCloseFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiTransactionsbatchCloseFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiTransactionsbatchedFormatGetCollectionQueryKey = (options: Options<ApiTransactionsbatchedFormatGetCollectionData>) => createQueryKey('apiTransactionsbatchedFormatGetCollection', options);

/**
 * Retrieves the collection of BatchedTransaction resources.
 * Retrieves the collection of BatchedTransaction resources.
 */
export const apiTransactionsbatchedFormatGetCollectionOptions = (options: Options<ApiTransactionsbatchedFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsbatchedFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsbatchedFormatGetCollectionQueryKey(options)
    });
};

export const apiTransactionsbatchedFormatGetCollectionInfiniteQueryKey = (options: Options<ApiTransactionsbatchedFormatGetCollectionData>): QueryKey<Options<ApiTransactionsbatchedFormatGetCollectionData>> => createQueryKey('apiTransactionsbatchedFormatGetCollection', options, true);

/**
 * Retrieves the collection of BatchedTransaction resources.
 * Retrieves the collection of BatchedTransaction resources.
 */
export const apiTransactionsbatchedFormatGetCollectionInfiniteOptions = (options: Options<ApiTransactionsbatchedFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiTransactionsbatchedFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiTransactionsbatchedFormatGetCollectionResponse>, QueryKey<Options<ApiTransactionsbatchedFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiTransactionsbatchedFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiTransactionsbatchedFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiTransactionsbatchedFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsbatchedFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiTransactionsbatchedTransactionIdFormatGetQueryKey = (options: Options<ApiTransactionsbatchedTransactionIdFormatGetData>) => createQueryKey('apiTransactionsbatchedTransactionIdFormatGet', options);

/**
 * Retrieves a BatchedTransaction resource.
 * Retrieves a BatchedTransaction resource.
 */
export const apiTransactionsbatchedTransactionIdFormatGetOptions = (options: Options<ApiTransactionsbatchedTransactionIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsbatchedTransactionIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsbatchedTransactionIdFormatGetQueryKey(options)
    });
};

export const apiTransactionsblindReturnFormatPostQueryKey = (options: Options<ApiTransactionsblindReturnFormatPostData>) => createQueryKey('apiTransactionsblindReturnFormatPost', options);

/**
 * Creates a BlindReturnResource resource.
 * Creates a BlindReturnResource resource.
 */
export const apiTransactionsblindReturnFormatPostOptions = (options: Options<ApiTransactionsblindReturnFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsblindReturnFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsblindReturnFormatPostQueryKey(options)
    });
};

/**
 * Creates a BlindReturnResource resource.
 * Creates a BlindReturnResource resource.
 */
export const apiTransactionsblindReturnFormatPostMutation = (options?: Partial<Options<ApiTransactionsblindReturnFormatPostData>>): UseMutationOptions<ApiTransactionsblindReturnFormatPostResponse, AxiosError<ApiTransactionsblindReturnFormatPostError>, Options<ApiTransactionsblindReturnFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiTransactionsblindReturnFormatPostResponse, AxiosError<ApiTransactionsblindReturnFormatPostError>, Options<ApiTransactionsblindReturnFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiTransactionsblindReturnFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiTransactionscheckStoreFormatPostQueryKey = (options: Options<ApiTransactionscheckStoreFormatPostData>) => createQueryKey('apiTransactionscheckStoreFormatPost', options);

/**
 * Creates a CheckStoreResource resource.
 * Creates a CheckStoreResource resource.
 */
export const apiTransactionscheckStoreFormatPostOptions = (options: Options<ApiTransactionscheckStoreFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionscheckStoreFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionscheckStoreFormatPostQueryKey(options)
    });
};

/**
 * Creates a CheckStoreResource resource.
 * Creates a CheckStoreResource resource.
 */
export const apiTransactionscheckStoreFormatPostMutation = (options?: Partial<Options<ApiTransactionscheckStoreFormatPostData>>): UseMutationOptions<ApiTransactionscheckStoreFormatPostResponse, AxiosError<ApiTransactionscheckStoreFormatPostError>, Options<ApiTransactionscheckStoreFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiTransactionscheckStoreFormatPostResponse, AxiosError<ApiTransactionscheckStoreFormatPostError>, Options<ApiTransactionscheckStoreFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiTransactionscheckStoreFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiTransactionsdeclinedFormatGetCollectionQueryKey = (options: Options<ApiTransactionsdeclinedFormatGetCollectionData>) => createQueryKey('apiTransactionsdeclinedFormatGetCollection', options);

/**
 * Retrieves the collection of DeclinedTransaction resources.
 * Retrieves the collection of DeclinedTransaction resources.
 */
export const apiTransactionsdeclinedFormatGetCollectionOptions = (options: Options<ApiTransactionsdeclinedFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsdeclinedFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsdeclinedFormatGetCollectionQueryKey(options)
    });
};

export const apiTransactionsdeclinedFormatGetCollectionInfiniteQueryKey = (options: Options<ApiTransactionsdeclinedFormatGetCollectionData>): QueryKey<Options<ApiTransactionsdeclinedFormatGetCollectionData>> => createQueryKey('apiTransactionsdeclinedFormatGetCollection', options, true);

/**
 * Retrieves the collection of DeclinedTransaction resources.
 * Retrieves the collection of DeclinedTransaction resources.
 */
export const apiTransactionsdeclinedFormatGetCollectionInfiniteOptions = (options: Options<ApiTransactionsdeclinedFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiTransactionsdeclinedFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiTransactionsdeclinedFormatGetCollectionResponse>, QueryKey<Options<ApiTransactionsdeclinedFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiTransactionsdeclinedFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiTransactionsdeclinedFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiTransactionsdeclinedFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsdeclinedFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiTransactionsdeclinedTransactionIdFormatGetQueryKey = (options: Options<ApiTransactionsdeclinedTransactionIdFormatGetData>) => createQueryKey('apiTransactionsdeclinedTransactionIdFormatGet', options);

/**
 * Retrieves a DeclinedTransaction resource.
 * Retrieves a DeclinedTransaction resource.
 */
export const apiTransactionsdeclinedTransactionIdFormatGetOptions = (options: Options<ApiTransactionsdeclinedTransactionIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsdeclinedTransactionIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsdeclinedTransactionIdFormatGetQueryKey(options)
    });
};

export const apiTransactionserrorFormatGetCollectionQueryKey = (options: Options<ApiTransactionserrorFormatGetCollectionData>) => createQueryKey('apiTransactionserrorFormatGetCollection', options);

/**
 * Retrieves the collection of ErrorTransaction resources.
 * Retrieves the collection of ErrorTransaction resources.
 */
export const apiTransactionserrorFormatGetCollectionOptions = (options: Options<ApiTransactionserrorFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionserrorFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionserrorFormatGetCollectionQueryKey(options)
    });
};

export const apiTransactionserrorFormatGetCollectionInfiniteQueryKey = (options: Options<ApiTransactionserrorFormatGetCollectionData>): QueryKey<Options<ApiTransactionserrorFormatGetCollectionData>> => createQueryKey('apiTransactionserrorFormatGetCollection', options, true);

/**
 * Retrieves the collection of ErrorTransaction resources.
 * Retrieves the collection of ErrorTransaction resources.
 */
export const apiTransactionserrorFormatGetCollectionInfiniteOptions = (options: Options<ApiTransactionserrorFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiTransactionserrorFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiTransactionserrorFormatGetCollectionResponse>, QueryKey<Options<ApiTransactionserrorFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiTransactionserrorFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiTransactionserrorFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiTransactionserrorFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionserrorFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiTransactionserrorTransactionIdFormatGetQueryKey = (options: Options<ApiTransactionserrorTransactionIdFormatGetData>) => createQueryKey('apiTransactionserrorTransactionIdFormatGet', options);

/**
 * Retrieves a ErrorTransaction resource.
 * Retrieves a ErrorTransaction resource.
 */
export const apiTransactionserrorTransactionIdFormatGetOptions = (options: Options<ApiTransactionserrorTransactionIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionserrorTransactionIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionserrorTransactionIdFormatGetQueryKey(options)
    });
};

export const apiTransactionsincrementalFormatPostQueryKey = (options: Options<ApiTransactionsincrementalFormatPostData>) => createQueryKey('apiTransactionsincrementalFormatPost', options);

/**
 * Creates a IncrementalResource resource.
 * Creates a IncrementalResource resource.
 */
export const apiTransactionsincrementalFormatPostOptions = (options: Options<ApiTransactionsincrementalFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsincrementalFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsincrementalFormatPostQueryKey(options)
    });
};

/**
 * Creates a IncrementalResource resource.
 * Creates a IncrementalResource resource.
 */
export const apiTransactionsincrementalFormatPostMutation = (options?: Partial<Options<ApiTransactionsincrementalFormatPostData>>): UseMutationOptions<ApiTransactionsincrementalFormatPostResponse, AxiosError<ApiTransactionsincrementalFormatPostError>, Options<ApiTransactionsincrementalFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiTransactionsincrementalFormatPostResponse, AxiosError<ApiTransactionsincrementalFormatPostError>, Options<ApiTransactionsincrementalFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiTransactionsincrementalFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiTransactionsreEnterFormatPostQueryKey = (options: Options<ApiTransactionsreEnterFormatPostData>) => createQueryKey('apiTransactionsreEnterFormatPost', options);

/**
 * Creates a ReEnterResource resource.
 * Creates a ReEnterResource resource.
 */
export const apiTransactionsreEnterFormatPostOptions = (options: Options<ApiTransactionsreEnterFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsreEnterFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsreEnterFormatPostQueryKey(options)
    });
};

/**
 * Creates a ReEnterResource resource.
 * Creates a ReEnterResource resource.
 */
export const apiTransactionsreEnterFormatPostMutation = (options?: Partial<Options<ApiTransactionsreEnterFormatPostData>>): UseMutationOptions<ApiTransactionsreEnterFormatPostResponse, AxiosError<ApiTransactionsreEnterFormatPostError>, Options<ApiTransactionsreEnterFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiTransactionsreEnterFormatPostResponse, AxiosError<ApiTransactionsreEnterFormatPostError>, Options<ApiTransactionsreEnterFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiTransactionsreEnterFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiTransactionsreturnFormatPostQueryKey = (options: Options<ApiTransactionsreturnFormatPostData>) => createQueryKey('apiTransactionsreturnFormatPost', options);

/**
 * Creates a ReturnResource resource.
 * Creates a ReturnResource resource.
 */
export const apiTransactionsreturnFormatPostOptions = (options: Options<ApiTransactionsreturnFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsreturnFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsreturnFormatPostQueryKey(options)
    });
};

/**
 * Creates a ReturnResource resource.
 * Creates a ReturnResource resource.
 */
export const apiTransactionsreturnFormatPostMutation = (options?: Partial<Options<ApiTransactionsreturnFormatPostData>>): UseMutationOptions<ApiTransactionsreturnFormatPostResponse, AxiosError<ApiTransactionsreturnFormatPostError>, Options<ApiTransactionsreturnFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiTransactionsreturnFormatPostResponse, AxiosError<ApiTransactionsreturnFormatPostError>, Options<ApiTransactionsreturnFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiTransactionsreturnFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiTransactionsreversalFormatPostQueryKey = (options: Options<ApiTransactionsreversalFormatPostData>) => createQueryKey('apiTransactionsreversalFormatPost', options);

/**
 * Creates a ReversalResource resource.
 * Creates a ReversalResource resource.
 */
export const apiTransactionsreversalFormatPostOptions = (options: Options<ApiTransactionsreversalFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsreversalFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsreversalFormatPostQueryKey(options)
    });
};

/**
 * Creates a ReversalResource resource.
 * Creates a ReversalResource resource.
 */
export const apiTransactionsreversalFormatPostMutation = (options?: Partial<Options<ApiTransactionsreversalFormatPostData>>): UseMutationOptions<ApiTransactionsreversalFormatPostResponse, AxiosError<ApiTransactionsreversalFormatPostError>, Options<ApiTransactionsreversalFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiTransactionsreversalFormatPostResponse, AxiosError<ApiTransactionsreversalFormatPostError>, Options<ApiTransactionsreversalFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiTransactionsreversalFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiTransactionssaleFormatPostQueryKey = (options: Options<ApiTransactionssaleFormatPostData>) => createQueryKey('apiTransactionssaleFormatPost', options);

/**
 * Creates a SaleResource resource.
 * Creates a SaleResource resource.
 */
export const apiTransactionssaleFormatPostOptions = (options: Options<ApiTransactionssaleFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionssaleFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionssaleFormatPostQueryKey(options)
    });
};

/**
 * Creates a SaleResource resource.
 * Creates a SaleResource resource.
 */
export const apiTransactionssaleFormatPostMutation = (options?: Partial<Options<ApiTransactionssaleFormatPostData>>): UseMutationOptions<ApiTransactionssaleFormatPostResponse, AxiosError<ApiTransactionssaleFormatPostError>, Options<ApiTransactionssaleFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiTransactionssaleFormatPostResponse, AxiosError<ApiTransactionssaleFormatPostError>, Options<ApiTransactionssaleFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiTransactionssaleFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiTransactionssettledFormatGetCollectionQueryKey = (options: Options<ApiTransactionssettledFormatGetCollectionData>) => createQueryKey('apiTransactionssettledFormatGetCollection', options);

/**
 * Retrieves the collection of SettledTransaction resources.
 * Retrieves the collection of SettledTransaction resources.
 */
export const apiTransactionssettledFormatGetCollectionOptions = (options: Options<ApiTransactionssettledFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionssettledFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionssettledFormatGetCollectionQueryKey(options)
    });
};

export const apiTransactionssettledFormatGetCollectionInfiniteQueryKey = (options: Options<ApiTransactionssettledFormatGetCollectionData>): QueryKey<Options<ApiTransactionssettledFormatGetCollectionData>> => createQueryKey('apiTransactionssettledFormatGetCollection', options, true);

/**
 * Retrieves the collection of SettledTransaction resources.
 * Retrieves the collection of SettledTransaction resources.
 */
export const apiTransactionssettledFormatGetCollectionInfiniteOptions = (options: Options<ApiTransactionssettledFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiTransactionssettledFormatGetCollectionResponse, AxiosError<DefaultError>, InfiniteData<ApiTransactionssettledFormatGetCollectionResponse>, QueryKey<Options<ApiTransactionssettledFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiTransactionssettledFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiTransactionssettledFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiTransactionssettledFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionssettledFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiTransactionssettledTransactionIdFormatGetQueryKey = (options: Options<ApiTransactionssettledTransactionIdFormatGetData>) => createQueryKey('apiTransactionssettledTransactionIdFormatGet', options);

/**
 * Retrieves a SettledTransaction resource.
 * Retrieves a SettledTransaction resource.
 */
export const apiTransactionssettledTransactionIdFormatGetOptions = (options: Options<ApiTransactionssettledTransactionIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionssettledTransactionIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionssettledTransactionIdFormatGetQueryKey(options)
    });
};

export const apiTransactionsstoreFormatPostQueryKey = (options: Options<ApiTransactionsstoreFormatPostData>) => createQueryKey('apiTransactionsstoreFormatPost', options);

/**
 * Creates a StoreResource resource.
 * Creates a StoreResource resource.
 */
export const apiTransactionsstoreFormatPostOptions = (options: Options<ApiTransactionsstoreFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsstoreFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsstoreFormatPostQueryKey(options)
    });
};

/**
 * Creates a StoreResource resource.
 * Creates a StoreResource resource.
 */
export const apiTransactionsstoreFormatPostMutation = (options?: Partial<Options<ApiTransactionsstoreFormatPostData>>): UseMutationOptions<ApiTransactionsstoreFormatPostResponse, AxiosError<ApiTransactionsstoreFormatPostError>, Options<ApiTransactionsstoreFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiTransactionsstoreFormatPostResponse, AxiosError<ApiTransactionsstoreFormatPostError>, Options<ApiTransactionsstoreFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiTransactionsstoreFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiTransactionsvoidFormatPostQueryKey = (options: Options<ApiTransactionsvoidFormatPostData>) => createQueryKey('apiTransactionsvoidFormatPost', options);

/**
 * Creates a VoidResource resource.
 * Creates a VoidResource resource.
 */
export const apiTransactionsvoidFormatPostOptions = (options: Options<ApiTransactionsvoidFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsvoidFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsvoidFormatPostQueryKey(options)
    });
};

/**
 * Creates a VoidResource resource.
 * Creates a VoidResource resource.
 */
export const apiTransactionsvoidFormatPostMutation = (options?: Partial<Options<ApiTransactionsvoidFormatPostData>>): UseMutationOptions<ApiTransactionsvoidFormatPostResponse, AxiosError<ApiTransactionsvoidFormatPostError>, Options<ApiTransactionsvoidFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiTransactionsvoidFormatPostResponse, AxiosError<ApiTransactionsvoidFormatPostError>, Options<ApiTransactionsvoidFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiTransactionsvoidFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiTransactionsTransactionIdreceiptFormatGetQueryKey = (options: Options<ApiTransactionsTransactionIdreceiptFormatGetData>) => createQueryKey('apiTransactionsTransactionIdreceiptFormatGet', options);

/**
 * Retrieves a GetTransactionReceiptResource resource.
 * Retrieves a GetTransactionReceiptResource resource.
 */
export const apiTransactionsTransactionIdreceiptFormatGetOptions = (options: Options<ApiTransactionsTransactionIdreceiptFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiTransactionsTransactionIdreceiptFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiTransactionsTransactionIdreceiptFormatGetQueryKey(options)
    });
};

export const apiUsersFormatGetCollectionQueryKey = (options?: Options<ApiUsersFormatGetCollectionData>) => createQueryKey('apiUsersFormatGetCollection', options);

/**
 * A collection of users
 * Retrieves the collection of User resources.
 */
export const apiUsersFormatGetCollectionOptions = (options?: Options<ApiUsersFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersFormatGetCollectionQueryKey(options)
    });
};

export const apiUsersFormatGetCollectionInfiniteQueryKey = (options?: Options<ApiUsersFormatGetCollectionData>): QueryKey<Options<ApiUsersFormatGetCollectionData>> => createQueryKey('apiUsersFormatGetCollection', options, true);

/**
 * A collection of users
 * Retrieves the collection of User resources.
 */
export const apiUsersFormatGetCollectionInfiniteOptions = (options?: Options<ApiUsersFormatGetCollectionData>) => {
    return infiniteQueryOptions<ApiUsersFormatGetCollectionResponse, AxiosError<ApiUsersFormatGetCollectionError>, InfiniteData<ApiUsersFormatGetCollectionResponse>, QueryKey<Options<ApiUsersFormatGetCollectionData>>, number | Pick<QueryKey<Options<ApiUsersFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ApiUsersFormatGetCollectionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await apiUsersFormatGetCollection({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersFormatGetCollectionInfiniteQueryKey(options)
    });
};

export const apiUsersPostQueryKey = (options: Options<ApiUsersPostData>) => createQueryKey('apiUsersPost', options);

/**
 * Register new user
 * # Register new user
 */
export const apiUsersPostOptions = (options: Options<ApiUsersPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersPostQueryKey(options)
    });
};

/**
 * Register new user
 * # Register new user
 */
export const apiUsersPostMutation = (options?: Partial<Options<ApiUsersPostData>>): UseMutationOptions<unknown, AxiosError<ApiUsersPostError>, Options<ApiUsersPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiUsersPostError>, Options<ApiUsersPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiUsersmeFormatGetQueryKey = (options?: Options<ApiUsersmeFormatGetData>) => createQueryKey('apiUsersmeFormatGet', options);

/**
 * Get current user information
 * Retrieves a User resource.
 */
export const apiUsersmeFormatGetOptions = (options?: Options<ApiUsersmeFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersmeFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersmeFormatGetQueryKey(options)
    });
};

/**
 * Updates the PatchChangePasswordResource resource.
 * Updates the PatchChangePasswordResource resource.
 */
export const apiUsersmechangePasswordFormatPatchMutation = (options?: Partial<Options<ApiUsersmechangePasswordFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiUsersmechangePasswordFormatPatchError>, Options<ApiUsersmechangePasswordFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiUsersmechangePasswordFormatPatchError>, Options<ApiUsersmechangePasswordFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersmechangePasswordFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updates the PatchDisableMfaResource resource.
 * Updates the PatchDisableMfaResource resource.
 */
export const apiUsersmedisableMfaFormatPatchMutation = (options?: Partial<Options<ApiUsersmedisableMfaFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiUsersmedisableMfaFormatPatchError>, Options<ApiUsersmedisableMfaFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiUsersmedisableMfaFormatPatchError>, Options<ApiUsersmedisableMfaFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersmedisableMfaFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiUsersmegenerateMfaBackupCodesFormatPostQueryKey = (options: Options<ApiUsersmegenerateMfaBackupCodesFormatPostData>) => createQueryKey('apiUsersmegenerateMfaBackupCodesFormatPost', options);

/**
 * Creates a PostGenerateBackupCodeResource resource.
 * Creates a PostGenerateBackupCodeResource resource.
 */
export const apiUsersmegenerateMfaBackupCodesFormatPostOptions = (options: Options<ApiUsersmegenerateMfaBackupCodesFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersmegenerateMfaBackupCodesFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersmegenerateMfaBackupCodesFormatPostQueryKey(options)
    });
};

/**
 * Creates a PostGenerateBackupCodeResource resource.
 * Creates a PostGenerateBackupCodeResource resource.
 */
export const apiUsersmegenerateMfaBackupCodesFormatPostMutation = (options?: Partial<Options<ApiUsersmegenerateMfaBackupCodesFormatPostData>>): UseMutationOptions<ApiUsersmegenerateMfaBackupCodesFormatPostResponse, AxiosError<ApiUsersmegenerateMfaBackupCodesFormatPostError>, Options<ApiUsersmegenerateMfaBackupCodesFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiUsersmegenerateMfaBackupCodesFormatPostResponse, AxiosError<ApiUsersmegenerateMfaBackupCodesFormatPostError>, Options<ApiUsersmegenerateMfaBackupCodesFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersmegenerateMfaBackupCodesFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiUsersmegenerateMfaEmailAuthCodeFormatPostQueryKey = (options: Options<ApiUsersmegenerateMfaEmailAuthCodeFormatPostData>) => createQueryKey('apiUsersmegenerateMfaEmailAuthCodeFormatPost', options);

/**
 * Creates a PostGenerateEmailAuthCodeResource resource.
 * Creates a PostGenerateEmailAuthCodeResource resource.
 */
export const apiUsersmegenerateMfaEmailAuthCodeFormatPostOptions = (options: Options<ApiUsersmegenerateMfaEmailAuthCodeFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersmegenerateMfaEmailAuthCodeFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersmegenerateMfaEmailAuthCodeFormatPostQueryKey(options)
    });
};

/**
 * Creates a PostGenerateEmailAuthCodeResource resource.
 * Creates a PostGenerateEmailAuthCodeResource resource.
 */
export const apiUsersmegenerateMfaEmailAuthCodeFormatPostMutation = (options?: Partial<Options<ApiUsersmegenerateMfaEmailAuthCodeFormatPostData>>): UseMutationOptions<unknown, AxiosError<ApiUsersmegenerateMfaEmailAuthCodeFormatPostError>, Options<ApiUsersmegenerateMfaEmailAuthCodeFormatPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiUsersmegenerateMfaEmailAuthCodeFormatPostError>, Options<ApiUsersmegenerateMfaEmailAuthCodeFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersmegenerateMfaEmailAuthCodeFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiUsersmegenerateMfaGoogleTotpFormatPostQueryKey = (options: Options<ApiUsersmegenerateMfaGoogleTotpFormatPostData>) => createQueryKey('apiUsersmegenerateMfaGoogleTotpFormatPost', options);

/**
 * Creates a PostGenerateGoogleTotpResource resource.
 * Creates a PostGenerateGoogleTotpResource resource.
 */
export const apiUsersmegenerateMfaGoogleTotpFormatPostOptions = (options: Options<ApiUsersmegenerateMfaGoogleTotpFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersmegenerateMfaGoogleTotpFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersmegenerateMfaGoogleTotpFormatPostQueryKey(options)
    });
};

/**
 * Creates a PostGenerateGoogleTotpResource resource.
 * Creates a PostGenerateGoogleTotpResource resource.
 */
export const apiUsersmegenerateMfaGoogleTotpFormatPostMutation = (options?: Partial<Options<ApiUsersmegenerateMfaGoogleTotpFormatPostData>>): UseMutationOptions<ApiUsersmegenerateMfaGoogleTotpFormatPostResponse, AxiosError<ApiUsersmegenerateMfaGoogleTotpFormatPostError>, Options<ApiUsersmegenerateMfaGoogleTotpFormatPostData>> => {
    const mutationOptions: UseMutationOptions<ApiUsersmegenerateMfaGoogleTotpFormatPostResponse, AxiosError<ApiUsersmegenerateMfaGoogleTotpFormatPostError>, Options<ApiUsersmegenerateMfaGoogleTotpFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersmegenerateMfaGoogleTotpFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiUsersmemfaProvidersFormatGetCollectionQueryKey = (options?: Options<ApiUsersmemfaProvidersFormatGetCollectionData>) => createQueryKey('apiUsersmemfaProvidersFormatGetCollection', options);

/**
 * Retrieves list MFA method enabled of current user
 * List MFA methods
 */
export const apiUsersmemfaProvidersFormatGetCollectionOptions = (options?: Options<ApiUsersmemfaProvidersFormatGetCollectionData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersmemfaProvidersFormatGetCollection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersmemfaProvidersFormatGetCollectionQueryKey(options)
    });
};

export const apiUsersmemfaProvidersFormatPostQueryKey = (options: Options<ApiUsersmemfaProvidersFormatPostData>) => createQueryKey('apiUsersmemfaProvidersFormatPost', options);

/**
 * Set MFA Provider using to authenticate request
 * Set MFA Provider
 */
export const apiUsersmemfaProvidersFormatPostOptions = (options: Options<ApiUsersmemfaProvidersFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersmemfaProvidersFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersmemfaProvidersFormatPostQueryKey(options)
    });
};

/**
 * Set MFA Provider using to authenticate request
 * Set MFA Provider
 */
export const apiUsersmemfaProvidersFormatPostMutation = (options?: Partial<Options<ApiUsersmemfaProvidersFormatPostData>>): UseMutationOptions<unknown, AxiosError<ApiUsersmemfaProvidersFormatPostError>, Options<ApiUsersmemfaProvidersFormatPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiUsersmemfaProvidersFormatPostError>, Options<ApiUsersmemfaProvidersFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersmemfaProvidersFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updates the PatchPreferMfaProviderResource resource.
 * Updates the PatchPreferMfaProviderResource resource.
 */
export const apiUsersmepreferMfaFormatPatchMutation = (options?: Partial<Options<ApiUsersmepreferMfaFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiUsersmepreferMfaFormatPatchError>, Options<ApiUsersmepreferMfaFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiUsersmepreferMfaFormatPatchError>, Options<ApiUsersmepreferMfaFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersmepreferMfaFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiUsersmesetupMfaEmailAuthCodeFormatPostQueryKey = (options: Options<ApiUsersmesetupMfaEmailAuthCodeFormatPostData>) => createQueryKey('apiUsersmesetupMfaEmailAuthCodeFormatPost', options);

/**
 * Creates a PostSetupEmailAuthCodeResource resource.
 * Creates a PostSetupEmailAuthCodeResource resource.
 */
export const apiUsersmesetupMfaEmailAuthCodeFormatPostOptions = (options: Options<ApiUsersmesetupMfaEmailAuthCodeFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersmesetupMfaEmailAuthCodeFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersmesetupMfaEmailAuthCodeFormatPostQueryKey(options)
    });
};

/**
 * Creates a PostSetupEmailAuthCodeResource resource.
 * Creates a PostSetupEmailAuthCodeResource resource.
 */
export const apiUsersmesetupMfaEmailAuthCodeFormatPostMutation = (options?: Partial<Options<ApiUsersmesetupMfaEmailAuthCodeFormatPostData>>): UseMutationOptions<unknown, AxiosError<ApiUsersmesetupMfaEmailAuthCodeFormatPostError>, Options<ApiUsersmesetupMfaEmailAuthCodeFormatPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiUsersmesetupMfaEmailAuthCodeFormatPostError>, Options<ApiUsersmesetupMfaEmailAuthCodeFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersmesetupMfaEmailAuthCodeFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiUsersmesetupMfaGoogleTotpFormatPostQueryKey = (options: Options<ApiUsersmesetupMfaGoogleTotpFormatPostData>) => createQueryKey('apiUsersmesetupMfaGoogleTotpFormatPost', options);

/**
 * Creates a PostSetupGoogleTotpResource resource.
 * Creates a PostSetupGoogleTotpResource resource.
 */
export const apiUsersmesetupMfaGoogleTotpFormatPostOptions = (options: Options<ApiUsersmesetupMfaGoogleTotpFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersmesetupMfaGoogleTotpFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersmesetupMfaGoogleTotpFormatPostQueryKey(options)
    });
};

/**
 * Creates a PostSetupGoogleTotpResource resource.
 * Creates a PostSetupGoogleTotpResource resource.
 */
export const apiUsersmesetupMfaGoogleTotpFormatPostMutation = (options?: Partial<Options<ApiUsersmesetupMfaGoogleTotpFormatPostData>>): UseMutationOptions<unknown, AxiosError<ApiUsersmesetupMfaGoogleTotpFormatPostError>, Options<ApiUsersmesetupMfaGoogleTotpFormatPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiUsersmesetupMfaGoogleTotpFormatPostError>, Options<ApiUsersmesetupMfaGoogleTotpFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersmesetupMfaGoogleTotpFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiUsersrequestResetPasswordFormatPostQueryKey = (options: Options<ApiUsersrequestResetPasswordFormatPostData>) => createQueryKey('apiUsersrequestResetPasswordFormatPost', options);

/**
 * Creates a ResetPasswordTokenResource resource.
 * Creates a ResetPasswordTokenResource resource.
 */
export const apiUsersrequestResetPasswordFormatPostOptions = (options: Options<ApiUsersrequestResetPasswordFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersrequestResetPasswordFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersrequestResetPasswordFormatPostQueryKey(options)
    });
};

/**
 * Creates a ResetPasswordTokenResource resource.
 * Creates a ResetPasswordTokenResource resource.
 */
export const apiUsersrequestResetPasswordFormatPostMutation = (options?: Partial<Options<ApiUsersrequestResetPasswordFormatPostData>>): UseMutationOptions<unknown, AxiosError<ApiUsersrequestResetPasswordFormatPostError>, Options<ApiUsersrequestResetPasswordFormatPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiUsersrequestResetPasswordFormatPostError>, Options<ApiUsersrequestResetPasswordFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersrequestResetPasswordFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * MFA Reset
 * # Reset mfa and backup codes
 */
export const apiUsersresetMfaAccountIdFormatPatchMutation = (options?: Partial<Options<ApiUsersresetMfaAccountIdFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiUsersresetMfaAccountIdFormatPatchError>, Options<ApiUsersresetMfaAccountIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiUsersresetMfaAccountIdFormatPatchError>, Options<ApiUsersresetMfaAccountIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersresetMfaAccountIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiUsersresetPasswordFormatPostQueryKey = (options: Options<ApiUsersresetPasswordFormatPostData>) => createQueryKey('apiUsersresetPasswordFormatPost', options);

/**
 * Creates a ResetPasswordTokenResource resource.
 * Creates a ResetPasswordTokenResource resource.
 */
export const apiUsersresetPasswordFormatPostOptions = (options: Options<ApiUsersresetPasswordFormatPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersresetPasswordFormatPost({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersresetPasswordFormatPostQueryKey(options)
    });
};

/**
 * Creates a ResetPasswordTokenResource resource.
 * Creates a ResetPasswordTokenResource resource.
 */
export const apiUsersresetPasswordFormatPostMutation = (options?: Partial<Options<ApiUsersresetPasswordFormatPostData>>): UseMutationOptions<unknown, AxiosError<ApiUsersresetPasswordFormatPostError>, Options<ApiUsersresetPasswordFormatPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiUsersresetPasswordFormatPostError>, Options<ApiUsersresetPasswordFormatPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersresetPasswordFormatPost({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiUsersresetPasswordIdFormatGetQueryKey = (options: Options<ApiUsersresetPasswordIdFormatGetData>) => createQueryKey('apiUsersresetPasswordIdFormatGet', options);

/**
 * Retrieves a ResetPasswordTokenResource resource.
 * Retrieves a ResetPasswordTokenResource resource.
 */
export const apiUsersresetPasswordIdFormatGetOptions = (options: Options<ApiUsersresetPasswordIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersresetPasswordIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersresetPasswordIdFormatGetQueryKey(options)
    });
};

/**
 * Delete a single user
 * Removes the User resource.
 */
export const apiUsersIdDeleteMutation = (options?: Partial<Options<ApiUsersIdDeleteData>>): UseMutationOptions<ApiUsersIdDeleteResponse, AxiosError<ApiUsersIdDeleteError>, Options<ApiUsersIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<ApiUsersIdDeleteResponse, AxiosError<ApiUsersIdDeleteError>, Options<ApiUsersIdDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersIdDelete({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const apiUsersIdFormatGetQueryKey = (options: Options<ApiUsersIdFormatGetData>) => createQueryKey('apiUsersIdFormatGet', options);

/**
 * A single user
 * Retrieves a User resource.
 */
export const apiUsersIdFormatGetOptions = (options: Options<ApiUsersIdFormatGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apiUsersIdFormatGet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: apiUsersIdFormatGetQueryKey(options)
    });
};

/**
 * Update a single user
 * Updates the PatchUserResource resource.
 */
export const apiUsersIdFormatPatchMutation = (options?: Partial<Options<ApiUsersIdFormatPatchData>>): UseMutationOptions<unknown, AxiosError<ApiUsersIdFormatPatchError>, Options<ApiUsersIdFormatPatchData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<ApiUsersIdFormatPatchError>, Options<ApiUsersIdFormatPatchData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await apiUsersIdFormatPatch({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};